import * as React from "react";
import Select from "react-select";
import { languageModal } from "../loc/Clm365ContractManagementWebPartStrings";
import * as yup from "yup";
import { customStyles, selectDisabled } from "../UtilityFunctions/ReactSelectStyles";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import TextField from '../UtilityFunctions/CustomTextField';
import {
  _FetchColumns,
  CalcuateBusinessDays,
  createTasksinbatch,
  deleteFile,
  deleteFileFromFolder,
  fetchAppUsers,
  fetchRequestData,
  fetchRequestListData,
  getAllApprovalInfos,
  getAllBusinussunitOptions,
  getAllContractNames,
  getContractDetails,
  getcounterpartyDetails,
  getCustomColumns,
  getDatafromreqlist,
  getDocumentAttachments,
  getGroupIdByName,
  getRequestNumberSequence,
  getroledata,
  updateCurrentSequence,
  updateDocumentAttachments,
  Updateformfieldvalues,
  uploadExistFolderFilesInBatch,
  validateApproval,
} from "../UtilityFunctions/CommonFunction";
import {
  DetailsList,
  IColumn,
  IDetailsListStyles,
  Icon,
  SelectionMode,
  Dropdown,
  IDropdownOption,
  IDropdownStyles,
  DatePicker,
  PrimaryButton,
  MessageBar,
  MessageBarType,
  IChoiceGroupOption,
  IChoiceGroupStyles,
  ChoiceGroup,
  Link,
  Label,
  Dialog,
  DialogType,
  IStyleFunctionOrObject,
  IDialogStyleProps,
  IDialogStyles,
  TooltipHost,
  IconButton,
  FontIcon,
  ITooltipHostStyles,
  DefaultButton,
  DialogFooter,
  IIconProps,
  IModalProps,
  Checkbox,
  ICheckboxStyles,
  Callout,
  mergeStyleSets,
  Spinner,
  ResponsiveMode,
} from "office-ui-fabric-react";
import SettingService from "../../services/SettingService";
import DragAndDrop from "../DragnDrop/DragAndDrop";
import CustomAttachment from "../DragnDrop/CustomAttachment";
import AddTermDialog from "./AddTermDialog";
import axios from "axios";
import { useGetSet } from "react-use";
import { SweetAlerts } from "../UtilityFunctions/SweetAlerts";
import { GetAllBusinessUnitName } from "../Fetchers/HomeRequest";
import { GetAllContractTypeNameHome, GetAllDocDisplayFieldName } from "../Fetchers/CurrentContractType";
import { GetAllDisplayFieldName } from "../Fetchers/CurrentRequestFields";
import ContextService from "../../services/ContextService";
import {
  choiceGroupStyles,
  counterpartyoption,
  // Delete,
  dropdownStyles,
  hostStyles,
  onFormatDate,
} from "../UtilityFunctions/Constants/Constants";
import { Web } from "sp-pnp-js";
import { useBoolean } from "@uifabric/react-hooks";
import moment from "moment";
import { useImmer } from "use-immer";
import ActivityService from "../../services/ActivityService";
import { v4 as uuid } from "uuid";
import { DeleteRegular } from '@fluentui/react-icons';
import { isStringValidated, SelectTheme } from "../Global/constants";
import { ContractCostTextField, convertCurrency, getFilteredPaymentTerms } from "../UtilityFunctions/RequestFunctions";

// import { Guid } from "@microsoft/sp-core-library";
let allRequestItems = [];
let setatt1 = [];
let setatt = [];
let allItems = [];
let optionConName = [];
let allAttachementFiles = [];
let CurrentdisplayDocfieldsTemp;
let CurrentdisplayfieldsNameTemp;
let draftfiledata = [];
let remarksetatt = [];
let remarksetatt1 = [];
let allActivityLogs = [];
let addattachmentNames = [];
let taskJSON = [];
let taskJSONTemp = [];
let DraftApproval='';
let AllfieldValues;
let RequestNumberSeq2: any;
let requestnumbertemp: any;
let Contract_Request_Title;
let allMails;
let businessData=[]
let allApprovalData = [];
let isOptional = false;
let businessuserManager;
let businessuserManagerManger;
let workflowempapproversemail;
let workflowempapproversids;
let workflowempapproversname;
  let ActivityDraft="EditRequest"
function UpdateExisting(props) {
  // console.log(props);
  const licence_Key = "trial";
  const reactQuillRef = React.useRef(null);
  const BusinessUnit=props.SettingsListData['DisplayBusinessUnit']||"No";
  const Department = props.SettingsListData['DisplayDepartment'] || "No";
  const CurrentUser = JSON.parse(localStorage.getItem("CurrentUser")||"{}");
  const hideSampleData = JSON.parse(props.SettingsListData?.RequestContractSampleData || '{}')?.RequestSampleData === 'No';
  const activeContractsCount=3;
  const uniqueGUID = uuid();
  const settingsCurrency = JSON.parse(props?.SettingsListData.OrganizationInfo || "[]")[0]?.Currency || JSON.parse('{"key":"USD_$","text":"USD"}')
  const strings = languageModal.getLanguageContent();
  const [fromFields, setFromFields] = React.useState({});
  const [allRequestOpt, setAllRequestOpt] = React.useState([]);
  const [Users, setUsers] = React.useState([]);
  const [formfieldjson, setformfieldjson] = React.useState<string>();
  const [selectedRequest, setSelectedRequest] = React.useState(undefined);
  const [spinnerLoading, setspinnerLoading] = React.useState(false);
  const [data, setData] = useGetSet<any>({});
  const { SweetAlert: Sweetalerteditrequest } = SweetAlerts("#Sweetalerteditrequest");
  const { SweetAlert: SweetAlertEditDraft } = SweetAlerts("#Sweetalerteditrequest");
  const { SweetAlert: SweetAlertEditCommentsrequest } = SweetAlerts("#Sweetalerteditrequest");
  const [approvalInfo, setApprovalInfo] = useImmer([]);
  const [RequestLoading, setRequestLoading] = React.useState(false);
  const [dataText, setdataText] = React.useState({});
  const [dataNote, setdataNote] = React.useState({});
  const [dataNumber, setdataNumber] = React.useState({});
  const [dateDatepicker, setdateDatepicker] = React.useState({});
  const [dataChoice2, setdataChoice2] = React.useState({});
  const [documentTypesData, setDocumentTypesData] = React.useState({});
  const [finalconditional, setfinalconditional] = React.useState([]);
  const [attachmentFileData, setAttachmentFileData] = React.useState({});
  const [finalconditionNumber, setfinalconditionNumber] = React.useState([]);
  const [rejectedSubmit, setRejectedSubmit] = React.useState<any>("No");
  const [ButtonSaveText, setButtonSaveText] = React.useState<string>(strings.Update);
  const [ButtonSaveText1, setButtonSaveText1] = React.useState<string>(strings.UpdateSubmit);
  const [Buttonsubmit, setButtonsubmit] = React.useState<string>(strings.Update);
  const [isTermDialogvisible, setIsTermDialogvisible] = React.useState<boolean>(false);
  const [ShareWith, setShareWith] = useGetSet({
      shareWithSelected : [],
      ShareWithOptions: []
  });
  const [DepartmentDetails, setDepartmentDetails] = useGetSet({
    SelectedDepartment: "",
    DepartmentOptions: []
  })
  const [ContractCostData, setContractCostData] = React.useState({
      selectedCurrencyKey:settingsCurrency?.key,
      selectedCurrency:settingsCurrency?.text,
      selectedAmount:"",
      settingsCurrency:settingsCurrency?.text,
      settingsAmount:""
    });
  // const [termObj, setTermObj] = React.useState<any>({});
  const [loading, setLoading] = React.useState(false);
  const [loading3, setLoading3] = React.useState(false);
  const [loading1, setLoading1] = React.useState(false);

  const [drag, SetDrag] = React.useState(false);
  const [isDialogvisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
  const [
    isremarkDialogvisible,
    { setTrue: showremarkDialog, setFalse: hideremarkDialog },
  ] = useBoolean(false);
  const [
    isDialogvisibleOptional,
    { setTrue: showDialogOptional, setFalse: hideDialogOptional },
  ] = useBoolean(false);

  const [drafttypeoption, setDrafttypeoption] = React.useState<IDropdownOption[]>([
    { key: "Attach your own file", text: "Attach your own file" },
    { key: "Blank", text: "Blank" },
    { key: "Standard Template", text: "Standard Template" },
  ]);
  const requesttype: IDropdownOption[] = [
    { key: "Contract", text: "New Contract" },
    { key: "Amendment", text: "Amendment" },
    { key: "Renewal", text: "Renewal" },
  ]?.filter((item) =>
    !["p3a", "p4a", "trial"].includes(licence_Key)
      ? !["Renewal", "Amendment"].includes(item.key)
        ? true
        : null
      : true
  );

  const stylesCallout = mergeStyleSets({
    callout: {
      width: 300,
      maxWidth: "90%",
      height: 128,
      padding: "8px 8px",
      background: "var(--settingsCardBackground) !important",
      overflowy: "hidden",
    },
  });

  function handleOnChange(event, item) {
    setFromFields((prev) => {
      const temp = { ...prev };
      temp[item] = event.target.value;
      return temp;
    });
  }

  React.useEffect(() => {
    getAllRequestData();
  }, []);

  React.useEffect(() => {
    if (dateDatepicker["Contract_End_Date"]) {
      setData((c) => ({
        ...c,
        isDisabled: false,
        showDurationTextField: false,
        selectedTerm: "",
      }));
    } else if (!dateDatepicker["Contract_End_Date"] && !data()?.iscloseVisible) {
      setData((c) => ({
        ...c,
        isDisabled: true,
        showDurationTextField: true,
        selectedTerm: "Indefinite",
      }));
    } else if (!dateDatepicker["Contract_End_Date"] && data()?.iscloseVisible) {
      setData((c) => ({
        ...c,
        isDisabled: false,
        showDurationTextField: true,
        selectedTerm: "",
      }));
    }
  }, [dateDatepicker]);

  React.useEffect(() => {
    if (data()?.status == "Draft") {
      getRequestNumberSequence(setData,data);
    }
  }, [data()?.businessunitdropvalue, data()?.contracttypeId]);

  const handleTextChange = (newValue) => {
      setData((c)=>({
      ...c,
      remark: newValue
    }))
}

  const getShareWithOptions = async () => {
    try {
      let groupOptions =[]
      const newUsers = Users?.filter(i=>i.id !== CurrentUser?.currentUserId).map(i => ({
          ...i,
          label: i.text,
          value : i.text,
          isShareWith: true
        }));
      const res = await getroledata();
      const groupsObj = res?.userGroups?.[0] || {};

      if(res.userGroups){
        groupOptions = await Promise.all(
          Object.keys(groupsObj)?.map(async (group) => ({
            key: group,
            text: group,
            value: group,
            label: group,
            id: await getGroupIdByName(group),
          }))
        );
      }
      const allOptions = [...newUsers, ...groupOptions];
      setShareWith({shareWithSelected : [], ShareWithOptions: allOptions});
    } catch (err) {
      console.error("Error loading ShareWith options:", err);
    }
  };
  
  const getAllRequestData = async () => {
    try {
      const requestItems = await fetchRequestListData(hideSampleData);
      // console.log(requestItems);
      const requestOptions = [];
      allRequestItems = [...requestItems];
      requestItems?.map((request) => {
        requestOptions.push({
          key: request?.Guid_ID,
          text: request?.Title,
          value: request?.Guid_ID,
          label: request?.Title,
        });
      });
      setAllRequestOpt(requestOptions);

      const [
        Busunitdata,
        Contractunitdata,
        CurrentDocdisplayfields,
        Currentdisplayfields,
        optionsCounterparty,
        columnsdata,
        roleData,
        allApprovalData,
      ] = await Promise.all([
        GetAllBusinessUnitName({}),
        GetAllContractTypeNameHome({}),
        GetAllDocDisplayFieldName({}),
        GetAllDisplayFieldName({}),

        getcounterpartyDetails(),
        _FetchColumns(),
        getroledata(),
        getAllApprovalInfos(),
      ]);
      CurrentdisplayDocfieldsTemp = CurrentDocdisplayfields;
      Currentdisplayfields["Contract_End_Date"] = "Contract Duration";

      CurrentdisplayfieldsNameTemp = Currentdisplayfields;
      const allContractNames = await getAllContractNames(Busunitdata, Contractunitdata);
      optionConName = [...allContractNames];
      const allBusinessUnits = await getAllBusinussunitOptions(Busunitdata);
      setData((c) => ({
        ...c,
        CurrentdisplayDocfields: CurrentDocdisplayfields,
        currentbusUnitName: Busunitdata,
        currentContractName: Contractunitdata,
        CurrentdisplayfieldsName: Currentdisplayfields ?? {},
        contracttypename: [...allContractNames],
        activityLog: allBusinessUnits?.activityLog,
        BusinessunitOptions: allBusinessUnits?.BusinessunitOptions,
        optionsCounterparty: optionsCounterparty,
        orgDetailsfinal: roleData?.orgDetailsfinal,
        allRoleOptions: roleData?.allRoleOptions,
        newColumn: columnsdata?.newColumn ?? [],
        placeholders: columnsdata?.placeholders,
        allApprovalData: allApprovalData,
      }));
      setDepartmentDetails((prev) => ({ ...prev, DepartmentOptions: roleData?.departmentOptions }))
      const usersOptions= await fetchAppUsers();
      setUsers(usersOptions||[])
    } catch (error) {
      console.log(error);
    }
  };

  const onChangeDepartmentDetails = (item) => {
    setDepartmentDetails((prev) => ({ ...prev, SelectedDepartment: item }))
  }

  const onChangeRequest = (item): void => {
    if (item) {
      setSelectedRequest(item.key as string);
      getRequestData(item.key);
      getShareWithOptions();
    }
  };
  let heightValue = "";
  const handleDrag = (event) => {
    event.preventDefault();
    SetDrag(true);
    drag ? heightValue == "7rem" : heightValue == "0rem";
    setTimeout(() => {
      SetDrag(false);
    }, 1000);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setTimeout(() => {
      SetDrag(false);
    }, 1000);
  };

  const getRequestData = async (reqGuid) => {
    allActivityLogs=[]
    setRequestLoading(true);
    try {
      if(data() && Object.keys(data())?.length){
      ActivityDraft=''
      const requestItem: any = await fetchRequestData(reqGuid);

      const requestData = requestItem[0];
      const Contracttype = requestData?.Contract_Type ? requestData.Contract_Type.split("|") : "";
      const ContracttypeRowID = Contracttype[0];
      let standardtemp;
      let blankstatus = "";
      let standardfile = [];
      let fileIdupdate = "";
      allActivityLogs.push(...JSON.parse(requestData.Activity_Log))
      const contractDetails = await getContractDetails(
        ContracttypeRowID,
        data()?.CurrentdisplayfieldsName,
        data()?.newColumn
      );
      const customColumns: any = await getCustomColumns(
        contractDetails?.DocumentTypeField,
        CurrentdisplayDocfieldsTemp
      );
      ActivityDraft=requestData?.Status=="Draft"?"Draft":"EditRequest"
      if (requestData?.Department) {
        const DepartmentData = DepartmentDetails().DepartmentOptions.find(i => i.key == requestData?.Department)
        setDepartmentDetails((prev) => ({ ...prev, SelectedDepartment: DepartmentData }))
      }
      if (requestData.Share_With_OthersId && requestData.Share_With_OthersId?.length > 0) {
        const Selected = ShareWith().ShareWithOptions?.filter(opt =>
        requestData?.Share_With_OthersId.some((sel) => sel === opt.id));
        setShareWith((pre) => ({
          ...pre,
          shareWithSelected: Selected
        }));
      }
      setData((c) => ({
        ...c,
        editid :requestData?.ID,
        DocumentTypeField: contractDetails?.DocumentTypeField,
        validateState: { ...contractDetails?.validateState, ...customColumns?.validateState },
        validatestate: { ...contractDetails?.validateState, ...customColumns?.validateState },
        _JsonFormFields: contractDetails?._JsonFormFields,
        conditionaldata: contractDetails?.conditionaldata,
        formfieldjson: contractDetails?._JsonFormFields,
        conditionaljson: contractDetails?.conditionaljson,
        GJsonFormFields: contractDetails?.GJsonFormFields,
        GJsonFormFieldsCond: contractDetails?.GJsonFormFieldsCond,
        filepath: contractDetails?.filepath,
        standardtemplatename: contractDetails?.standardtemplatename,
        businessunitdropvalue: contractDetails?.businessunitdropvalue,
        draftTypeOptions: contractDetails?.draftTypeOptions,
        documenttitle: customColumns?.documenttitle,
        documentTypesTemp: customColumns?.documentTypesTemp,
        documentTypes: customColumns?.documentTypes,
        contracttypeselect: parseInt(Contracttype[0]),
        drafttypelist: requestData?.Draft_Type,
        FileImported: false,
        selectedTerm: "",
        isTermDialogvisible: false,
      }));
      setformfieldjson(contractDetails?.GJsonFormFields);
      if (requestData.Draft_Type != "Attach your own file" && requestData.Draft_Type != "Blank") {
        standardtemp = contractDetails?.standardtemplatename;
      }
      if (requestData.Draft_Type == "Attach your own file") {
        standardfile = contractDetails?.standardtemplatename;
      } else if (requestData.Draft_Type == "Blank") {
        standardfile = contractDetails?.standardtemplatename;
        blankstatus = requestData.Draft_Type;
        fileIdupdate = requestData.Guid_ID;
      }

      setData((c) => ({
        ...c,
        blankstatus: blankstatus,
        standardfile: standardfile,
        fileIdupdate: fileIdupdate,
        standardtemp:standardtemp
      }));
      setDrafttypeoption((c) => {
        return c.map((item) => {
          if (item.key === "Standard Template") {
            return { ...item, text: contractDetails?.standardtemplatename };
          }
          return item;
        });
      });

      await getDatafromreqlist(
        requestData,
        setData,
        optionConName,
        data()?.BusinessunitOptions,
        contractDetails?.GJsonFormFields,
        contractDetails?.GJsonFormFieldsCond,
        getnumbervalue,
        getChoice
      );
      if(isStringValidated(requestData.Contract_Cost)){
          setContractCostData(JSON.parse(requestData?.Contract_Cost||"{}"))
          }
      setformfieldjson(data()?.GJsonFormFields);
      setdataText(data()?.dataText);
      setdataNote(data()?.dataNote);
      setdataNumber(data()?.dataNumber);
      setdataChoice2(data()?.dataChoice2);
      setdateDatepicker(data()?.dateDatepicker);
      await getDocumentAttachments(requestData?.Guid_ID, customColumns?.documentTypesTemp, setData);

      if (requestData.Draft_Type != "Blank") {
        await getAllFiles(requestData.File_Name, requestData.Draft_Type, requestData?.ActualFileName);
      }
      await getFilesByTask(requestData.Guid_ID);

      // allAttachementFiles = [];
      setRequestLoading(false);
    }
    } catch (error) {
      setRequestLoading(false);
      console.log(error);
    }
  };

  async function getAllFiles(FileName, drafttype, docname) {

      try{
        const token = localStorage.getItem("CurrentToken");
        const response = await axios.get(
          `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('CLM365RequestDraft')/files('${FileName}')?$expand=ListItemAllFields`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json;odata=verbose",
            },
          }
        );


        const e = response?.data?.d;
        const doclibname = e?.Name;
        let filenamenew = (e?.Name).split(".");
        let f1 = filenamenew.slice(0, -1);
        // setfileIdupdate(f1.join("."));
        let standardFile = [];
        let selectedStandFile;
        let selectedthirdFile;
        if (drafttype != "Attach your own file" && drafttype != "Blank") {
          // setstandardfile(
          standardFile = [
            <div>
              <div
                className={"Attatchemntdiv"}
                title={docname}
                style={{ marginTop: "5px", width: "auto", maxWidth: "none" }}
              >
                <span className={"Attatcmenticons"}>
                  <Icon
                    styles={{
                      root: {
                        marginTop: "3px",
                        marginRight: "5px",
                        marginLeft: "5px",
                      },
                    }}
                    iconName="TextDocument"
                  ></Icon>
                </span>
                <span className={"Attatchmentext1"}>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    href={e?.ServerRelativeUrl}
                    target="_blank"
                    download={docname}
                  >
                    {docname}
                  </a>
                </span>
              </div>
            </div>,
          ];



          const listName = encodeURIComponent('CLM365RequestDraft');
          const serverRelativeUrl = e?.ServerRelativeUrl || "";  // The full ServerRelativeUrl (example: '/sites/clm365test/CLM365RequestDraft/fe3a605d-7b79-4a1d-b628-75b2fda56c71.docx')
const filePath = encodeURIComponent(serverRelativeUrl); 
          const curl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${filePath}')/$value`; 

          try{
            const token = localStorage.getItem("CurrentToken");
            const responseBlob:any= await axios({
              method: 'get',
              url: curl,
              headers: {
                'Authorization': `Bearer ${token}`,
                // 'Accept': 'application/json;odata=verbose'
              },
              responseType: 'blob' // Specify that you expect a blob response
            })
          
          
            // console.log(responseBlob)
            if(responseBlob?.data){
  
              const file = new File([responseBlob?.data], "template.docx", {
                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              });
              // console.log("FileContent",file,blob)
              // Convert the blob to text
              const reader = new FileReader();
              reader.onload = function (event) {
                const fileContent = event.target.result;
                //   console.log("File Content:", fileContent);
              };
              reader.readAsText(responseBlob?.data);
              selectedStandFile = file;
  
                // 
  
            }
          }catch(error){
            console.log(error)
          }

        }
        if (drafttype == "Attach your own file") {
          setatt1 = [];
          setatt = [];
          setatt.push(e);
          setatt1.push([
            <div className={"Attatchemntdiv"} title={docname} style={{ marginTop: "1.9rem", width: "100%" }}>
              <span className={"Attatcmenticons"}>
                <Icon
                  styles={{
                    root: {
                      marginTop: "3px",
                      marginRight: "5px",
                      marginLeft: "5px",
                    },
                  }}
                  iconName="TextDocument"
                ></Icon>
              </span>
              <span className={"Attatchmentext1"}>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href={e?.ServerRelativeUrl}
                  target="_blank"
                  download={docname}
                >
                  {docname}
                </a>
              </span>
              <Link onClick={deleteattach} style={{ marginLeft: "auto",paddingRight:'5px' }}>
      
                   <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
              </Link>
            </div>,
          ]);

          
          const listName = encodeURIComponent('CLM365RequestDraft');
          const serverRelativeUrl = e?.ServerRelativeUrl || "";  // The full ServerRelativeUrl (example: '/sites/clm365test/CLM365RequestDraft/fe3a605d-7b79-4a1d-b628-75b2fda56c71.docx')
const filePath = encodeURIComponent(serverRelativeUrl); 
          const curl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${filePath}')/$value`; 
          try{
            const token = localStorage.getItem("CurrentToken");
            const responseBlob:any= await axios({
              method: 'get',
              url: curl,
              headers: {
                'Authorization': `Bearer ${token}`,
                // 'Accept': 'application/json;odata=verbose'
              },
              responseType: 'blob' // Specify that you expect a blob response
            })
          
          
            // console.log(responseBlob)
            if(responseBlob?.data){
  
                      const file = new File([responseBlob?.data], "template.docx", {
                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              });
              // Updateformfieldvalues(AllfieldValues,file,fileName, finalTemplatelib);
              //console.log(file);
              selectedthirdFile = file;
  
            }
          }catch(error){
            console.log(error)
          }

 
        }

        setData((c) => ({
          ...c,
          doclibname: doclibname,
          fileIdupdate: f1.join("."),
          standardfile: standardFile,
          selectedStandfile: selectedStandFile,
          attachFile2: setatt,
          attachfile: setatt1,
          selectedthirdfile: selectedthirdFile,
        }));
      }catch(error){
        console.log(error)
      }


  }

  const getnumbervalue = (event): void => {
    let textfieldvalue = event.target.value;
    let _fieldInternalname = event.target.id;

    let _ChoiceArray = [];
    {
      data()?.GJsonFormFieldsCond
        ? Object.entries(data()?.GJsonFormFieldsCond).map(([key1, column]: any, index: any) => {
            if (key1 == _fieldInternalname) {
              column.Choices.length > 0
                ? column.Choices.map((data: any, ind: any) => {
                    if (data.Numbervalue == textfieldvalue) {
                      data.field.length
                        ? data.field.map((items) => {
                            _ChoiceArray.push({
                              FieldName: items.FieldName,
                              InternalName: items.InternalName,
                              Operator: data.Operator,
                              type: items.type,
                            });
                          })
                        : "";
                    }
                  })
                : null;
            }
          })
        : null;
    }

    setfinalconditionNumber((prev) => ({
      ...prev,
      [_fieldInternalname]: {
        // ...prev[_fieldchoicename],
        // [textfieldvalue]: {
        Fields: _ChoiceArray,
        // }
      },
    }));

    setformfieldjson(data()?.GJsonFormFields);
    dataNumber[event.target.id] = event.target.value;

    setdataNumber({ ...dataNumber });
    //////console.log({ ...dataNumber });
  };

  const getChoice = (item, id): void => {
    let _selectedValue = item.key;
    let _fieldchoicename = id;
    let _ChoiceArray = [];
    {
      data()?.GJsonFormFieldsCond
        ? Object.entries(data()?.GJsonFormFieldsCond).map(([key1, column]: any, index: any) => {
            if (key1 == _fieldchoicename) {
              column.Choices.length > 0
                ? column.Choices.map((data: any, ind: any) => {
                    if (data.value == _selectedValue) {
                      _ChoiceArray.push({
                        FieldName: data.FieldName,
                        InternalName: data.InternalName,
                        Operator: data.Operator,
                        type: data.type,
                      });
                      // let ApproverDetailnew1 = Object.assign({
                      //   [data.value]: {
                      //       "Approvers": [],
                      //   }
                      //});
                    }
                  })
                : null;
            }
          })
        : null;
    }
    setfinalconditional((prev) => ({
      ...prev,
      [_fieldchoicename]: {
        // ...prev[_fieldchoicename],
        [_selectedValue]: {
          Fields: _ChoiceArray,
        },
      },
    }));

    setData((c) => ({
      ...c,
      selectedchoice: _selectedValue,
    }));
    //////console.log(GJsonFormFields, "GJsonFormFields");
    setformfieldjson(data()?.GJsonFormFields);
    //////console.log(item.key, "item.key")
    dataChoice2[id] = item.key;
    setdataChoice2({ ...dataChoice2 });
  };

  async function getFilesByTask(RequestGuid) {
    try {
      // const web = new Web(ContextService.GetUrl());
      // const library = web.lists.getByTitle("CLM365TaskAttachment");
      // // Get the folder object by its server-relative URL
      // const rootFolder = await library.rootFolder.get();
      // const folderUrl = `${rootFolder.ServerRelativeUrl}/${RequestGuid}`;
      // const folder = web.getFolderByServerRelativeUrl(folderUrl);

      // Retrieve all files in the folder
      // const files = await folder.files.expand("ListItemAllFields").get();
      const token = localStorage.getItem("CurrentToken");
      const rootFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365TaskAttachment')/rootfolder`;
      const response = await axios.get(rootFolderUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const rootFolder = response.data;
      const folderUrl = `${rootFolder.ServerRelativeUrl}/${RequestGuid}`;
      // taskAttachmentRoot=folderUrl;
      // Request the files in the folder
      
      const filesUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files?$expand=ListItemAllFields`;
      const filesResponse = await axios.get(filesUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const files = filesResponse.data.value || [];

      // Process the files
      let varlnth1 = 0;
      remarksetatt1=[];
      remarksetatt=[]
      files.forEach((file) => {
        let internalname = "";
        const fileName = file.ListItemAllFields.File_Name;
      
        setatt1 = [];
        for (const key in data()?.attachmentFileDataTemp) {
          if (data()?.attachmentFileDataTemp.hasOwnProperty(key)) {
            const guid = data()?.attachmentFileDataTemp[key];

            if (guid === file.Name) {
              setatt1.push([
                <div className={"Attatchemntdiv"} title={fileName}>
                  <span className={"Attatcmenticons"}>
                    <Icon
                      styles={{
                        root: {
                          marginTop: "3px",
                          marginRight: "5px",
                          marginLeft: "5px",
                        },
                      }}
                      iconName="TextDocument"
                    ></Icon>
                  </span>
                  <span className={"Attatchmentext1"}>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      href={file.ServerRelativeUrl}
                      target="_blank"
                      download={fileName}
                    >
                      {fileName}
                    </a>
                  </span>
                  <Link
                    onClick={() => deleteCustomattach(key, guid)}
                    style={{ marginLeft: "auto",paddingRight:'5px' }}
                  >
                 
                    <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
                  </Link>
                </div>,
              ]);
              attachmentFileData[key] = [setatt1];
              setAttachmentFileData({ ...attachmentFileData });
            }
          }
        }

        for (const key in data()?.documentTypesKeyPairs) {
          if (data()?.documentTypesKeyPairs.hasOwnProperty(key)) {
            const guid = data()?.documentTypesKeyPairs[key];

            if (guid === file.Name) {
              setatt1.push([
                <div className={"Attatchemntdiv"} title={fileName}>
                  <span className={"Attatcmenticons"}>
                    <Icon
                      styles={{
                        root: {
                          marginTop: "3px",
                          marginRight: "5px",
                          marginLeft: "5px",
                        },
                      }}
                      iconName="TextDocument"
                    ></Icon>
                  </span>
                  <span className={"Attatchmentext1"}>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      href={file.ServerRelativeUrl}
                      target="_blank"
                      download={fileName}
                    >
                      {fileName}
                    </a>
                  </span>
                  <Link onClick={() => deleteDocumentTypes(key, guid)} style={{ marginLeft: "auto",paddingRight:'5px' }}>
                  
                     <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
                  </Link>
                </div>,
              ]);
              documentTypesData[key] = [setatt1];
              setDocumentTypesData({ ...documentTypesData });
            }
          }
        }

        if (file.ListItemAllFields?.AttachmentIntName === "Additional") {
          let id = varlnth1++;
          let delGuid = file.ListItemAllFields.File_Guid + "." + file.ListItemAllFields.File_Name?.split(".")[1];
          remarksetatt.push({
            name: fileName,
            content: file.ServerRelativeUrl,
            guid: delGuid,
          });
          remarksetatt1.push([
            <div className={"Attatchemntdiv"} title={fileName}>
              <span className={"Attatcmenticons"}>
                <Icon
                  styles={{
                    root: {
                      marginTop: "3px",
                      marginRight: "5px",
                      marginLeft: "5px",
                    },
                  }}
                  iconName="TextDocument"
                ></Icon>
              </span>
              <span className={"Attatchmentext1"}>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href={file.ServerRelativeUrl}
                  target="_blank"
                  download={fileName}
                >
                  {fileName}
                </a>
              </span>
              <Link onClick={() => deleteattachremark(id, delGuid)} style={{ marginLeft: "auto" ,paddingRight:'5px'}}>
                
                   <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
              </Link>
            </div>,
          ]);
        }

        // setAttachmentFileData({...attachmentFileData})
      });

      setData((c) => ({
        ...c,
        attachremarkFile1: [...remarksetatt1],
        attachremarkFile2: [...remarksetatt],
      }));
    } catch (error) {
      setData((c) => ({
        ...c,
        attachremarkFile1: [],
        attachremarkFile2: [],
      }));
      console.log(error);
    }
  }

  const onAttachmentChangeremark = (ev) => {
    if (ev.target.files.length > 0) {
      let varlnth1 = data()?.attachremarkFile2.length;
      let existingFileNames = data()?.attachremarkFile2.map((file) => file.name); // Store existing file names

      for (var i = 0; i < ev.target.files.length; i++) {
        if (!existingFileNames.includes(ev.target.files[i].name)) {
          // Check if the file already exists
          let id = varlnth1++;
          remarksetatt.push(ev.target.files[i]);
          addattachmentNames.push(ev.target.files[i].name);
          remarksetatt1.push([
            <div className={"Attatchemntdiv"} title={ev.target.files[i].name}>
              <span className={"Attatcmenticons"}>
                <Icon
                  styles={{
                    root: {
                      marginTop: "3px",
                      marginRight: "5px",
                      marginLeft: "5px",
                    },
                  }}
                  iconName="TextDocument"
                ></Icon>
              </span>
              <span className={"Attatchmentext1"}>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href={URL.createObjectURL(ev.target.files[i])}
                  target="_blank"
                  download={ev.target.files[i].name}
                >
                  {ev.target.files[i].name}
                </a>
              </span>
              <Link
                onClick={() => {
                  deleteattachremark(id, "");
                }}
                style={{paddingRight:'5px' }}
              >
            
                   <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
              </Link>
            </div>,
          ]);
        }
      }
      setData((c) => ({
        ...c,
        attachremarkFile1: [...remarksetatt1],
        attachremarkFile2: [...remarksetatt],
      }));
      // setattachremarkFile1([...remarksetatt1]);
      // setattachremarkFile2([...remarksetatt]);
    } else {
      // setattachremarkFile2(null);
      setData((c) => ({
        ...c,
        attachremarkFile2: null,
      }));
    }
  };

  function deleteattachremark(id, guid) {
    remarksetatt1 = [];
    remarksetatt.splice(id, 1);
    addattachmentNames = [];
    for (var i = 0; i < remarksetatt.length; i++) {
      let id = i;
      addattachmentNames.push(remarksetatt[i].name);
      remarksetatt1.push([
        <div
          className={"Attatchemntdiv"}
          title={remarksetatt[i].name}
          // style={{width:"10.8rem"}}
        >
          <span className={"Attatcmenticons"}>
            <Icon
              styles={{
                root: {
                  marginTop: "3px",
                  marginRight: "5px",
                  marginLeft: "5px",
                },
              }}
              iconName="TextDocument"
            ></Icon>
          </span>
          <span className={"Attatchmentext1"}>{remarksetatt[i].name}</span>
          <Link
            onClick={() => {
              deleteattachremark(id, remarksetatt[id].guid);
            }}
            style={{paddingRight:'5px'}}
          >
            {/* <span className="ms-Icon ms-Icon--Cancel" aria-hidden="true">X</span> */}
        
               <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
          </Link>
        </div>,
      ]);
    }
    // setattachremarkFile1([...remarksetatt1]);
    // setattachremarkFile2([...remarksetatt]);
    setData((c) => ({
      ...c,
      attachremarkFile1: [...remarksetatt1],
      attachremarkFile2: [...remarksetatt],
    }));
    if (guid != "") {
      const deleteRemark = data()?.deleteRemarkattach || [];
      deleteRemark.push(guid);
      // setDeleteRemarkAttach(deleteRemarkattach);
      setData((c) => ({
        ...c,
        attachremarkFile1: [...remarksetatt1],
        attachremarkFile2: [...remarksetatt],
        deleteRemarkattach: deleteRemark,
      }));
    }
  }

  function deleteDocumentTypes(internalname, guid) {
    // setFileImported(false);
    setDocumentTypesData((prevAttachmentData) => {
      let updatedAttachmentData = { ...prevAttachmentData };
      delete updatedAttachmentData[internalname];
      return updatedAttachmentData;
    });
    setatt1 = setatt1?.filter((attachment) => attachment.key !== internalname);
    // setDocumentTypeFiles((c) =>
    //   c?.filter((obj) => !obj.IntName || obj.IntName !== internalname)
    // );
    const documentType = data()?.documentTypeFiles?.filter((obj) => !obj.IntName || obj.IntName !== internalname);
    setData((c) => ({
      ...c,
      documentTypeFiles: documentType,
    }));
    if (guid != "") {
      // deleteDocumentsTypes[internalname] = guid;
      // setDeleteDocumentTypes({ ...deleteDocumentsTypes });
      const deleDocument = {
        ...data()?.deleteDocumentsTypes,
        [internalname]: guid,
      };
      setData((c) => ({
        ...c,
        deleteDocumentsTypes: deleDocument,
      }));
    }
  }
  const onAttachmentChange1 = (ev) => {
    if (ev.target.files.length > 0) {
      // setselectedthirdfile(ev.target.files[0]);
      draftfiledata.push(ev.target.files[0]);
      setatt1 = [];
      setatt = [];
      let varlnth = 0;
      for (var i = 0; i < ev.target.files.length; i++) {
        let id = varlnth++;
        setatt.push(ev.target.files[i]);
        setatt1.push([
          <div
            className={"Attatchemntdiv"}
            title={ev.target.files[i].name}
            style={{ marginTop: "28px", width: "24.5rem" }}
          >
            <span className={"Attatcmenticons"}>
              <Icon
                styles={{
                  root: {
                    // marginTop: "3px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  },
                }}
                iconName="TextDocument"
              ></Icon>
            </span>
            <span className={"Attatchmentext1"}>{ev.target.files[i].name}</span>
            <Link
              onClick={() => {
                deleteattach(id);
              }}
              style={{ marginLeft: "auto",paddingRight:'5px' }}
            >
           
                 <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
            </Link>
          </div>,
        ]);
      }

      setData((c) => ({
        ...c,
        attachFile2: setatt,
        attachfile: setatt1,
        selectedthirdfile: ev.target.files[0],
        FileImported: true,
      }));
      //setattachFile2(ev.target.files);
    } else {
      // setattachFile2(null);
      // setFileImported(false);
      setData((c) => ({
        ...c,
        attachFile2: null,
        FileImported: false,
      }));
      //setattachFile2(null);
    }
  };

  function deleteattach(id) {
    setatt1 = [];
    setatt.splice(id, 1);
    //console.log(setatt);
    for (var i = 0; i < setatt.length; i++) {
      let id = i;
      setatt1.push([
        <div>
          <span>{setatt[i].name}</span>
          <Link
            onClick={() => {
              deleteattach(id);
            }}
            style={{paddingRight:'5px'}}
          >
         
               <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
          </Link>
        </div>,
      ]);
    }

    // setAttachfile(setatt1);
    // setattachFile2(setatt);

    setData((c) => ({
      ...c,
      attachFile2: setatt,
      attachfile: setatt1,
      FileImported: false,
    }));
  }

  const gettextvalue = (event): void => {
    dataText[event.target.id] = event.target.value;
    setdataText({ ...dataText });
    setformfieldjson(data()?.GJsonFormFields);
  };
  const getnotevalue = (event): void => {
    dataNote[event.target.id] = event.target.value;
    setdataNote({ ...dataNote });
  };

  const onchangebusinessunit = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    let businessCode = "";
    data()?.businessunit.map((e) => {
      if (e.text == item.text) {
        // setBusinessCode(e.code);
        businessCode = e.code;
      }
    });
    setData((c) => ({
      ...c,
      businessCode: businessCode,
      businessunitdropvalue: item?.key as string,
      businessNameValue: item["guid"] as string,
    }));
  };
  const onChangeContractname = (
    event: React.FormEvent<HTMLDivElement>,
    item: IDropdownOption & { guid: string }
  ): void => {
    if (item) {
      let con_details = [];
      con_details.push(item.key);
      con_details.push(item.text);
      let _contractdata = con_details.join("|");
      // ////console.log(item.key, item.text);
      // setcontracttypeId(_contractdata as string);
      // getContractDetails(item.key);
      // setfiltercontractName(item.guid);
      let contractCode = "";
      data()?.contracttypename.map((e) => {
        if (e.text == item.text) {
          contractCode = e.code;
          // setContractCode(e.code);
        }
      });
      setData((c) => ({
        ...c,
        contractCode: contractCode,
        contracttypeId: _contractdata as string,
        filtercontractName: item.guid,
      }));
    }
    setfinalconditional([]);
  };
  const onChangeDrafttype = (item: IDropdownOption): void => {
    if (item) {
      let ServerRelativeUrl = data()?.draftTypeOptions?.filter((u) => u.key == item.key)[0].ServerRelativeUrl;
      // setselectedStandfile(ServerRelativeUrl)
      // setDrafttypelist(item.key as string);
      setData((c) => ({
        ...c,
        drafttypelist: item.key as string,
      }));
      // getfilebinarydata(ServerRelativeUrl, RequestGuid+".docx")
      fetch(ServerRelativeUrl)
        .then((res) => res.blob()) // Gets the response and returns it as a blob
        .then((blob) => {
          console.log("standdardtemp file blob then():Test 3");
          const file = new File([blob], data()?.RequestGuid + ".docx", {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          // setselectedStandfile(file);
          setData((c) => ({
            ...c,
            selectedStandfile: file,
          }));
        });
    }
  };

  function onChangeCParty(selected, intname) {
     if (intname === "Share_With_Others") {
    setShareWith((pre)=> ({...pre, shareWithSelected: selected || []}))
  } else {
    const counterPartyItems = [];
    if (selected) {
      selected?.map((items) => {
        let arr = {
          key: items.key,
          Counterpartyname: items.text,
          OrgName: items.value,
          Country: items.value1,
          State: items.State,
          City: items.City,
          ZipCode: items.ZipCode,
          Address_Line_1: items.Address1,
          Address_Line_2: items.Address2,
          Contact_Number: items.Contactnumber,
          email: items.email,
          OrganizationJurisdiction: items.OrganizationJurisdiction,
          Guid_ID: items.Guid_ID,
        };
        //console.log(arr, "arr");
        counterPartyItems.push(arr);
      });
    }
    setData((c) => ({
      ...c,
      counterpartyname: counterPartyItems,
    }));
    // setcounterpartyname(counterPartyItems);
  }
}

  const ondobChange = (date, id): void => {
    dateDatepicker[id] = date;
    if (id === "Contract_Start_Date") {
      dateDatepicker["Contract_End_Date"] = undefined;
      setdateDatepicker({ ...dateDatepicker });

      setData((c) => ({
        ...c,
        iscloseVisible: true,
      }));
      dateDatepicker["Contract_Start_Date"] = date;
      setformfieldjson(data()?.GJsonFormFields);
    } else {
      updateTermObjOnEndDateChange();
      let startD = dateDatepicker["Contract_Start_Date"];
      let endD = dateDatepicker["Contract_End_Date"];
      startD == null || startD == undefined
        ? (startD = date)
        : endD == null || endD == undefined
          ? (endD = date)
          : null;

      startD?.getFullYear() > endD?.getFullYear()
        ? datepickererror()
        : startD?.getFullYear() == endD?.getFullYear() && startD?.getMonth() > endD?.getMonth()
          ? datepickererror()
          : startD?.getFullYear() == endD?.getFullYear() &&
              startD?.getMonth() == endD?.getMonth() &&
              startD?.getDate() > endD?.getDate()
            ? datepickererror()
            : startD?.getFullYear() <= endD?.getFullYear() &&
                startD?.getMonth() <= endD?.getMonth() &&
                startD?.getDate() <= endD?.getDate()
              ? (setdateDatepicker({ ...dateDatepicker }),
                (dateDatepicker["Contract_End_Date"] = date),
                setformfieldjson(data()?.GJsonFormFields))
              : null;
    }
  };
  function updateTermObjOnEndDateChange() {
    let diff_days = moment(dateDatepicker["Contract_End_Date"]).diff(
      moment(dateDatepicker["Contract_Start_Date"]),
      "days"
    );
    setData((c) => ({
      ...c,
      termObj: { count: diff_days + 1, term: "Day" },
    }));
  }
  const onChangechoicegrp = React.useCallback((ev: React.SyntheticEvent<HTMLElement>, option: IChoiceGroupOption) => {
    // setselectedChoiceKey(option.key);
    setData((c) => ({
      ...c,
      selectedChoiceKey: option.key == "Definite" ? "Definite" : "Indefinite",
    }));
    // if (option.key == "Definite") {
    //   setselectedChoiceKey("Definite");
    // } else {
    //   setselectedChoiceKey("Indefinite");
    // }
  }, []);
  const onCustomAttachmentChange = (ev, internalname, FileGuid) => {
    // console.log(ev,"ev");
    // console.log(internalname,"internalname");
    // console.log(ev.target.files[0],"ev.target.files[0]");

    if (ev.target.files.length > 0) {
      setatt1 = [];
      setatt = [];
      for (var i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        setatt.push({
          IntName: internalname,
          FileName: ev.target.files[i]?.name,
          FileContent: ev.target.files[i],
          FileGuid: FileGuid ?? uuid().toString(),
        });
        setatt1.push([
          <div
            className={"CustomAttatchemntdiv"}
            title={ev.target.files[i].name}
            // style={{ marginTop: "-5px"}}
          >
            <span className={"Attatcmenticons"}>
              <Icon
                styles={{
                  root: {
                    marginTop: "3px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  },
                }}
                iconName="TextDocument"
              ></Icon>
            </span>
            <span className={"Attatchmentext1"}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href={URL.createObjectURL(file)}
                target="_blank"
                download={file.name}
              >
                {file.name}
              </a>
            </span>
            <Link
              onClick={() => {
                deleteCustomattach(internalname, "");
              }}
              style={{ marginLeft: "auto",paddingRight:'5px' }}
            >
              {/* <span
                className="ms-Icon ms-Icon--Cancel"
                aria-hidden="true"
                // className={"Attachmentdelete"}
                style={{ marginRight: "10px" }}
              >
                X
              </span> */}
          
                 <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
            </Link>
          </div>,
        ]);
      }

      attachmentFileData[internalname] = [setatt1];
      setData((c) => ({
        ...c,
        attachmentFile: [
          ...(c?.attachmentFile || []),
          ...(setatt || []),
        ],
      }));
      // setAttachmentFile([...attachmentFile, ...setatt]);
    }
  };

  function deleteCustomattach(internalname, guid) {
    // setFileImported(false);
    setAttachmentFileData((prevAttachmentData) => {
      let updatedAttachmentData = { ...prevAttachmentData };
      delete updatedAttachmentData[internalname];
      return updatedAttachmentData;
    });
    setatt1 = setatt1?.filter((attachment) => attachment.key !== internalname);
    // setAttachmentFile((c) =>
    //   c?.filter((obj) => !obj.IntName || obj.IntName !== internalname)
    // );
    const attachFile = data()?.attachmentFile?.filter((obj) => !obj.IntName || obj.IntName !== internalname);
    setData((c) => ({
      ...c,
      attachmentFile: attachFile,
      FileImported: false,
    }));
    if (guid != "") {
      // deleteAttachmentFiles[internalname] = guid;
      // setDeleteAttachmentFiles({ ...deleteAttachmentFiles });
      let deleteAttachment = {
        ...data()?.deleteAttachmentFiles,
        [internalname]: guid,
      };
      setData((c) => ({
        ...c,
        deleteAttachmentFiles: deleteAttachment,
      }));
    }
  }

  const datepickererror = () => {
    dateDatepicker["Contract_End_Date"] = undefined;
    // dateDatepicker["Contract_End_Date"] = "";
    // seterrormsgStatus(true)
    // seterrormsgValue("End date can't be less than Start date")
    if (ActivityDraft == "EditRequest") {
      dateDatepicker["Contract_End_Date"] = undefined;
      Sweetalerteditrequest("error", `${strings.EndDateMessage}`);
    } else if (ActivityDraft == "CommentsEditRequest") {
      dateDatepicker["Contract_End_Date"] = undefined;
      SweetAlertEditCommentsrequest("error", `${strings.EndDateMessage}`);
    } else {
      dateDatepicker["Contract_End_Date"] = undefined;
      SweetAlertEditDraft("error", `${strings.EndDateMessage}`);
    }
    setdateDatepicker({ ...dateDatepicker });
    // setTimeout(() => {
    //   ErrorMsgVlidate();
    //   messageDismiss();
    //   seterrormsgValue("");
    //   // seterrormsgStatus(false)
    // }, 3000);
  };

  const onDocumentTypeChange = (ev, internalname, FileGuid) => {
    if (ev.target.files.length > 0) {
      setatt1 = [];
      setatt = [];
      for (var i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        setatt.push({
          IntName: internalname,
          FileName: ev.target.files[i]?.name,
          FileContent: ev.target.files[i],
          FileGuid: FileGuid,
        });
        setatt1.push([
          <div className={"CustomAttatchemntdiv"} title={ev.target.files[i].name}>
            <span className={"Attatcmenticons"}>
              <Icon
                styles={{
                  root: {
                    marginTop: "3px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  },
                }}
                iconName="TextDocument"
              ></Icon>
            </span>
            <span className={"Attatchmentext1"}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href={URL.createObjectURL(file)}
                target="_blank"
                download={file.name}
              >
                {file.name}
              </a>
            </span>
            <Link
              onClick={() => {
                deleteDocumentTypes(internalname, "");
              }}
              style={{ marginLeft: "auto",paddingRight:'5px' }}
            >
         
                 <DeleteRegular style={{color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important"}}/>
            </Link>
          </div>,
        ]);
      }

      documentTypesData[internalname] = [setatt1];

      // setDocumentTypeFiles([...documentTypeFiles, ...setatt]);
      setData((c) => ({
        ...c,
        documentTypeFiles: [...c.documentTypeFiles, ...setatt],
      }));
    }
  };

  function PostContractformdata(id, approvalInfo) {
    let ID = id;
    let placeholders=[...data()?.placeholders];
    requestnumbertemp=data()?.requestnumbertemp;
    let approvalAccess=[];
    let legalAccessUsers=[]
    // setSubmitDisabled(true);
    setspinnerLoading(true)
    setLoading1(true)
    // setdisableButton(true);
    if (
      ![null, undefined, ""].includes(data()?.remark) ||
      id == "Draft" ||
      data()?.status == "Rejected"
    ) {
      hideremarkDialog();
      let validationdata = data()?.validatestate;
      // if (selectedChoiceKey == "Indefinite") {
      if (data()?.selectedTerm == "Indefinite") {
        delete validationdata["Contract_End_Date"];
      }
      if (data()?.counterpartyname.length) {
        delete validationdata["Counterparty_Name"];
      }
      let validationSchema = yup.object(validationdata);
      validationSchema
        .validate({
          ...dataText,
          ...dataNumber,
          ...dataNote,
          ...dateDatepicker,
          ...dataChoice2,
          ...attachmentFileData,
          ...documentTypesData,
        })
        .then(async () => {
          let flag = false;
          if (
            licence_Key == "trial" &&
            activeContractsCount >= 10 &&
            id == "Publish"
          ) {
            flag = true;
            SweetAlertEditDraft(
              "error",
              "Contracts count exceeded. You are using the trial version. You can create up to 10 contracts. Consider upgrading to the Standard version for more."
            );
            setspinnerLoading(false)
          } else if (
            licence_Key.toLowerCase() == "p1a" &&
            activeContractsCount >= 30 &&
            id == "Publish"
          ) {
            flag = true;
        
            SweetAlertEditDraft(
              "error",
              "Contracts count exceeded. You are using the Standard version. You can create up to 30 contracts. Consider upgrading to the Plus version for more."
            );
            setspinnerLoading(false)
          } else if (
            licence_Key.toLowerCase() == "p2a" &&
            activeContractsCount >= 60 &&
            id == "Publish"
          ) {
            flag = true;
           
            SweetAlertEditDraft(
              "error",
              "Contracts count exceeded. You are using the Plus version. You can create up to 60 contracts. Consider upgrading to the Premium version for more."
            );
            setspinnerLoading(false)
          } else if (
            licence_Key.toLowerCase() == "p3a" &&
            activeContractsCount >= 120 &&
            id == "Publish"
          ) {
            flag = true;
            
            SweetAlertEditDraft(
              "error",
              "Contracts count exceeded. You are using the Premium version. You can create up to 120 contracts. Consider upgrading to the Enterprise version for more."
            );
            setspinnerLoading(false)
          } else if (
            licence_Key.toLowerCase() == "p4a" &&
            activeContractsCount >= 240 &&
            id == "Publish"
          ) {
            flag = true;
            SweetAlertEditDraft(
              "error",
              "Contracts count exceeded. You are using the Enterprise version. You can create up to 240 contracts."
            );
            setspinnerLoading(false)
          }
          if (!flag) {
            setspinnerLoading(true)
            if (id == "Publish") {
              id = "Pending";
              // setLoading(true);
              // setButtonSaveText1("");
              if (rejectedSubmit != "Yes") {
                setLoading3(true);
                setButtonsubmit("");
              } else {
                setLoading(true);
                setButtonSaveText1("");
              }
            } else if (id == "Draft") {
              setspinnerLoading(true)
              // SweetAlertEditDraft()
              if (data()?.drafttypelist == "Attach your own file") {
                if (data()?.attachfile?.length > 0) {
                  setLoading1(true);
                  setButtonSaveText("");
                } else {
                  setspinnerLoading(false)
                  SweetAlertEditDraft("error", `${strings.Pleaseattachfile}`);
                }
              } else {
                setLoading1(true);
                setButtonSaveText("");
              }
            }
            // let guidid = uniqueGUID.toString();
            let guidid = data()?.RequestGuid;
            let fileName;
            let requesterdraft;
            //drafttypelist == "Standard Template"
            if (
              data()?.drafttypelist != "Attach your own file" &&
              data()?.drafttypelist != "Blank"
            ) {
              if (data()?.standardtemp) {
                requesterdraft = data()?.drafttypelist; //standardtemp
              } else {
                requesterdraft = data()?.standardfile;
              }
              // requesterdraft = standardfile;
            } else if (data()?.drafttypelist == "Attach your own file") {
              // requesterdraft=attachFile1; //
              requesterdraft =
                data()?.attachfile[0][0].props.children[1].props.children?.props
                  ?.children ||
                  data()?.attachfile[0][0].props.children[1].props.children;
            }

            if (requesterdraft) {
              fileName = guidid.concat(
                ".",
                requesterdraft.split(".")[requesterdraft.split(".").length - 1]
              );
            }
            let finalfilename;
            if (data()?.blankstatus == "Blank") {
              let fileUNameExt =
                fileName?.split(".")?.[fileName?.split(".").length - 1];
              finalfilename =
                data()?.fileIdupdate?.replace(/#/g, "%23") +
                "." +
                fileUNameExt?.toLowerCase();
            }
            let approvaldataontype = data()?.allApprovalData?.filter((ele) => {
              return ele.Contracttype?.filter((item) => {
                item.key == data()?.contracttypeId;
              });
            });
      
            if (isOptional) {
              let taskcreated = true;
              taskJSON = [];
              approvalInfo.map((ele) => {
                let currentTask = JSON.parse(ele?.TaskData);
                if (taskcreated) {
                  if (
                    currentTask?.Status == "Approved" &&
                    currentTask?.Mandatory
                  ) {
                    currentTask?.AssignedToId != null
                      ? currentTask?.AssignedToId.forEach((v) => {
                          approvalAccess.push(v);
                        })
                      : (approvalAccess = []);
                    currentTask?.LegalUserId != null
                      ? currentTask?.LegalUserId.forEach((v) => {
                          legalAccessUsers.push(v);
                        })
                      : (legalAccessUsers = []);
                    if (
                      (approvalAccess?.length > 0 ||
                        legalAccessUsers?.length > 0) &&
                      currentTask?.Mandatory
                    ) {
                      taskJSON.push(currentTask);
                    }
                  } else {
                    currentTask?.AssignedToId != null
                      ? currentTask?.AssignedToId.forEach((v) => {
                          approvalAccess.push(v);
                        })
                      : (approvalAccess = []);
                    currentTask?.LegalUserId != null
                      ? currentTask?.LegalUserId.forEach((v) => {
                          legalAccessUsers.push(v);
                        })
                      : (legalAccessUsers = []);
                    if (
                      (approvalAccess?.length > 0 ||
                        legalAccessUsers?.length > 0) &&
                      currentTask?.Mandatory
                    ) {
                      taskJSON.push(currentTask);
                      taskcreated = false;
                    }
                  }
                }
              });
            }
            if (data()?.status == "Draft") {
              updateCurrentSequence(data,setData);
            }
            const d = new Date();
            let year = d.getFullYear().toString();
            let month = (d.getMonth() + 1).toString().padStart(2, "0");
            let day = d.getDate().toString().padStart(2, "0");
            let temp = {
              "Business Unit": data()?.businessUnitName,
              "Business Unit Code": data()?.businessCode,
              "Contract Type": data()?.contractName, //contractCode
              "Contract Type Code": data()?.contractCode,
              "Department Name": DepartmentDetails().SelectedDepartment["text"],
              "Department Code": DepartmentDetails().SelectedDepartment["code"],
              Year: year,
              "N/A": "",
              DD: day,
              MM: month,
              YYYY: year,
              DDMM: month + day,
              YYYMM: year.slice(2) + month,
              MMDD: month + day,
              DDMMYYYY: day + month + year,
              MMDDYYYY: month + day + year,
              YYYYMMDD: year + month + day,
              Sequence: data()?.requestsequencenum,
            };
            if (data()?.status == "Draft") {
              RequestNumberSeq2 = `${
                  temp[requestnumbertemp.DepartmentType]
                    ? temp[requestnumbertemp.DepartmentType] +
                      requestnumbertemp.DepartmentField
                    : ""
                }${
                temp[requestnumbertemp.Businessunit]
                  ? temp[requestnumbertemp.Businessunit] +
                    requestnumbertemp.Field1
                  : ""
              }${
                temp[requestnumbertemp.Contract]
                  ? temp[requestnumbertemp.Contract] + requestnumbertemp.Field2
                  : ""
              }${
                temp[requestnumbertemp.Year]
                  ? temp[requestnumbertemp.Year] + requestnumbertemp.Field3
                  : ""
              }${data()?.requestsequencenum || ""}`;
            }
    
            if (
              data()?.contracttypename?.filter(
                (i) => i?.guid == data()?.contracttypeId?.split("|")[1]
              )?.[0]?.UserGroup
            ) {
              
              let groupNames =   data()?.contracttypename
                ?.filter((i) => i?.guid == data()?.contracttypeId?.split("|")[1])?.[0]
                ?.UserGroup.map((i) => i.text);
            
              if (groupNames && groupNames != "") {
                for (let u = 0; u < groupNames.length; u++) {
                  let groupID = await getGroupIdByName(groupNames[u]);
                  if (groupID) {
                    approvalAccess?.push(groupID);
                  }
                }
              }
            }
            const convertedObj=await convertCurrency(ContractCostData?.selectedAmount,ContractCostData?.selectedCurrency,settingsCurrency?.text)
              const contractCost={
                      ...ContractCostData,
                      settingsAmount:convertedObj
                     }
            const Share_With_Others = ShareWith()?.shareWithSelected?.map(i=> i.id)
            let finalTemplate = {
              Contract_Type:data()?.contracttypeId,
              Contract_Term: data()?.selectedChoiceKey,
              Draft_Type: data()?.drafttypelist,
              Business_Unit: data()?.businessunitdropvalue,
              Counterparty_Name: JSON.stringify(data()?.counterpartyname),
              Guid_ID: guidid,
              File_Name: data()?.blankstatus != "Blank" ? data()?.doclibname : finalfilename,
              // Approval_Infos: JSON.stringify(approvalInfo),
              Status:
                data()?.status == "Rejected" && rejectedSubmit != "Yes"
                  ? "Rejected"
                  : id == "Draft"
                  ? "Draft"
                  : "Pending",
              Activity_Log: JSON.stringify(allActivityLogs),
              Request_Type: data()?.requesttypevalue,
              ActualFileName: requesterdraft,
              RequestApproval:
                data()?.status == "Draft" || data()?.requestApprovalstatus == "Completed"
                  ? "Completed"
                  : "Pending",
              // DraftApproval:DraftApproval,
              DraftApproval:
              data()?.DraftApprovalStatus != "Not Started"
                  ? data()?.DraftApprovalStatus
                  : DraftApproval,
              Request_Number:
                data()?.requestNumber != null ? data()?.requestNumber : RequestNumberSeq2,
              Term: JSON.stringify(data()?.termObj),
              Remarks: data()?.remark,
              Contract_Cost:JSON.stringify(contractCost||{}),
              Department: DepartmentDetails().SelectedDepartment["key"],
              Share_With_OthersId: Share_With_Others,
            };
            if (id == "Draft") {
              finalTemplate["Approval_Infos"] = JSON.stringify(approvalInfo); //
            }
            let finalTemplatelib = {
              File_Name: requesterdraft ? requesterdraft : "",
            };
            if (dataText != null) {
              var key;
              for (let value of Object.entries(dataText)) {
                // finalTemplate[value[0].replace(' ','_x0020_')] = value[1];
                finalTemplate[value[0]] = value[1];
              }
            }
            if (dataNote != null) {
              var key;
              for (let value of Object.entries(dataNote)) {
                finalTemplate[value[0]] = value[1];
              }
            }
            if (dataNumber != null) {
              var key;
              for (let value of Object.entries(dataNumber)) {
                finalTemplate[value[0]] = value[1];
              }
            }
            if (dataChoice2 != null) {
              var key;
              for (let value of Object.entries(dataChoice2)) {
                finalTemplate[value[0]] = value[1];
              }
            }
            if (dateDatepicker != null) {
              var key;
              for (let value of Object.entries(dateDatepicker)) {
                // if(selectedChoiceKey == "Indefinite" && value[0]=="Contract_End_Date" )
                if (
                  data()?.selectedTerm == "Indefinite" &&
                  value[0] == "Contract_End_Date"
                ) {
                  finalTemplate[value[0]] = null;
                } else {
                  [
                    "Contract_Date",
                    "Contract_End_Date",
                    "Contract_Start_Date",
                  ].includes(value[0])
                    ? (finalTemplate[value[0]] = moment(value[1]).format(
                        "MM/DD/YYYY"
                      ))
                    : (finalTemplate[value[0]] = value[1]);
                }
              }
            }
            if (data()?.attachmentFile != null && data()?.attachmentFile.length > 0) {
              for (let l = 0; l < data()?.attachmentFile.length; l++) {
                if (data()?.attachmentFile[l]) {
                  let fileGuid;
                  if (data()?.attachmentFile[l].FileGuid) {
                    fileGuid = data()?.attachmentFile[l].FileGuid.split(".")[0];
                  } else {
                    fileGuid = uuid()?.toString();
                  }

                  let finalTemplatelibrary = {
                    TaskID: finalTemplate["Guid_ID"],
                    File_Name: data()?.attachmentFile[l].FileName,
                    File_Guid: fileGuid,
                    AttachmentIntName: data()?.attachmentFile[l]?.IntName,
                  };
                  // let filename =fileGuid+"."+(data()?.attachmentFile[l].FileName).split('.')[1];
                  let filename =
                    fileGuid +
                    "." +
                    data()?.attachmentFile[l]?.FileName?.split(".")[
                      data()?.attachmentFile[l]?.FileName?.split(".")?.length - 1
                    ];
                  // addattachmentNameGuids.push(fileGuid);
                  finalTemplate[data()?.attachmentFile[l]?.IntName] = filename;
                  // data()?.attachmentFile[l]["GUID"] = filename;
                  setData((c) => {
                    const updatedAttachments = [...(c?.attachmentFile || [])];

                    if (updatedAttachments[l]) {
                      updatedAttachments[l] = {
                        ...updatedAttachments[l],
                        GUID: filename,
                      };
                    }

                    return {
                      ...c,
                      attachmentFile: updatedAttachments,
                    };
                  });
                }
              }
              // uploadFilesInBatch(attachmentFile, finalTemplate["Guid_ID"])
            }
            if (data()?.deleteAttachmentFiles != null && data()?.deleteAttachmentFiles) {
              let deletedFileNames = [];
              for (const key in data()?.deleteAttachmentFiles) {
                if (data()?.deleteAttachmentFiles.hasOwnProperty(key)) {
                  const guid = data()?.deleteAttachmentFiles[key];
                  let addedDeleteFiles = data()?.attachmentFile?.filter(
                    (e) => e?.IntName == key
                  );
                  if (addedDeleteFiles?.length == 0) {
                    finalTemplate[key] = "";
                    deletedFileNames.push(guid);
                    deleteFileFromFolder(finalTemplate["Guid_ID"], guid);
                  }
                }
              }
              
            }
            let documentTemplate = {};
            if (data()?.documentTypeFiles != null && data()?.documentTypeFiles.length > 0) {
              for (let l = 0; l < data()?.documentTypeFiles.length; l++) {
                if (data()?.documentTypeFiles[l]) {
                  let fileGuid;
                  if (data()?.documentTypeFiles[l].FileGuid) {
                    fileGuid = data()?.documentTypeFiles[l].FileGuid.split(".")[0];
                  } else {
                    fileGuid = uuid()?.toString();
                  }
                  let filename =
                    fileGuid +
                    "." +
                    data()?.documentTypeFiles[l]?.FileName?.split(".")[
                      data()?.documentTypeFiles[l]?.FileName?.split(".")?.length - 1
                    ];

                  documentTemplate[data()?.documentTypeFiles[l]?.IntName] = filename;

                  setData((c)=>({
                    ...c,
                    documentTypeFiles:c.documentTypeFiles[l]["GUID"] = filename,
                  }))
                  // data()?.documentTypeFiles[l]["GUID"] = filename;
                }
              }
              // uploadFilesInBatch(documentTypeFiles, finalTemplate["Guid_ID"])
            }
            if (data()?.deleteDocumentsTypes != null && data()?.deleteDocumentsTypes) {
              let deletedFileNames = [];
              for (const key in data()?.deleteDocumentsTypes) {
                if (data()?.deleteDocumentsTypes.hasOwnProperty(key)) {
                  const guid = data()?.deleteDocumentsTypes[key];
                  let addedDeleteFiles = data()?.documentTypeFiles?.filter(
                    (e) => e?.IntName == key
                  );
                  if (addedDeleteFiles?.length == 0) {
                    documentTemplate[key] = "";
                    deletedFileNames.push(guid);
                    deleteFileFromFolder(finalTemplate["Guid_ID"], guid);
                  }
                }
              }
              // deleteFilesInBatch(finalTemplate["Guid_ID"], deletedFileNames)
            }
            if (data()?.deleteRemarkattach != null && data()?.deleteRemarkattach) {
              let deletedFileNames = [];
              for (let i = 0; i < data()?.deleteRemarkattach.length; i++) {
                if (data()?.deleteRemarkattach.hasOwnProperty(i)) {
                  const guid = data()?.deleteRemarkattach[i];
                 
                  deleteFileFromFolder(finalTemplate["Guid_ID"], guid);
                  // }
                }
              }
             
            }
            if (
              (data()?.attachmentFile && data()?.attachmentFile != null) ||
              (data()?.documentTypeFiles != null && data()?.documentTypeFiles?.length > 0)
            ) {
              await uploadExistFolderFilesInBatch(
                [...data()?.attachmentFile, ...data()?.documentTypeFiles?? []],
                finalTemplate["Guid_ID"]
              );
            }

            if (Object.keys(documentTemplate)?.length !== 0) {
              documentTemplate["RequestContract_GuidID"] =
                finalTemplate["Guid_ID"];
                await updateDocumentAttachments(documentTemplate,data()?.documentTypeID);
            }
            let requiredFieldvalidate = [];
            var Errmessage = "A";

            placeholders = placeholders.map((c) => {
              const temp = { ...c };
              if (
                c.key == "Contract_Start_Date" ||
                c.key == "Contract_End_Date" ||
                c.key == "Contract_Date"
              ) {
                temp.Value = moment(new Date(finalTemplate[c.key])).format(
                  "MM/DD/YYYY"
                );
              } else if (c.key == "Contract_Type") {
                temp.Value = finalTemplate[c.key]?.split("|")[1];
              }

              else {
                temp.Value = finalTemplate[c.key];
              }
              return temp;
            });
            const modifiedURL = `${
              window.location.href.split("#")[0].split(".aspx")[0]
            }.aspx?TaskID=${
              finalTemplate["Guid_ID"]
            }&PanelName=${"RequestActivity"}#/`;
            const placeholders1 = [
              {
                key: "Business_Unit",
                Value: data()?.currentbusUnitName[data()?.businessunitdropvalue],
              },
              {
                key: "Contract_Type",
                Value: data()?.currentContractName[data()?.contracttypeId?.split("|")[1]],
              },
             
              {
                key: "Date",
                Value: moment(new Date()).format(
                  "MM/DD/YYYY"
                ),
              },
              {
                key: "Originator",
                Value: props?.currentUser.currentUserName,
              },
              {
                key: "Request_URL",
                Value: `<a href="${modifiedURL}" onclick="window.open(this.href, 'Snopzer',
              'left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" >Click here</a>`,
              },
            ];
            placeholders.push(...placeholders1);
            if (
              data()?.attachremarkFile2.length > 0 &&
              data()?.attachremarkFile2 != undefined
            ) {
              let attachremarkFiles = [];
              for (let i = 0; i < data()?.attachremarkFile2.length; i++) {
                let fileGuid = uuid()?.toString();
                let finalTemplatelibrary = {
                  TaskID: finalTemplate["Guid_ID"],
                  File_Name: data()?.attachremarkFile2[i].name,
                  File_Guid: fileGuid,
                };
                let finalTemp2 = {
                  TaskID: finalTemplate["Guid_ID"],
                  File_Name: data()?.attachremarkFile2[i].name,
                  File_Guid: fileGuid,
                  File_Content: data()?.attachremarkFile2[i],
                };
                allAttachementFiles.push(finalTemp2);
                if (!data()?.attachremarkFile2[i].guid) {
                  let filename =
                    fileGuid + "." + data()?.attachremarkFile2[i].name.split(".")[1];
                  // addattachmentNameGuids.push(fileGuid);
           
                  let finalTemp3 = {
                    GUID: filename,
                    FileName: data()?.attachremarkFile2[i].name,
                    FileContent: data()?.attachremarkFile2[i],
                    IntName: "Additional",
                  };
                  attachremarkFiles.push(finalTemp3);
                }

              }
             await uploadExistFolderFilesInBatch(attachremarkFiles, finalTemplate["Guid_ID"]);
            }
            let sendtoEmail = [ props?.currentUser.currentUserEmail];
            // draft and edit for email activitylog //
            allMails = {
              To: sendtoEmail,
              Cc: [],
            };
            const existingKeyIndex = placeholders.findIndex(
              (item) => item.key === "Remarks"
            );
            if (existingKeyIndex !== -1) {
              placeholders[existingKeyIndex].Value = data()?.remark;
            } else {
              placeholders.push({ key: "Remarks", Value: data()?.remark || "ok" });
            }
            allAttachementFiles = allAttachementFiles?.filter(
              (obj, index, self) =>
                index === self.findIndex((t) => t.File_Name === obj.File_Name)
            );
            if (id != "Draft") {
              if (ActivityDraft == "Draft") {
                let activityTemp =await ActivityService.getActivity(
                  "Request Submitted",
                  placeholders,
                  data()?.remark || " ",
                  allAttachementFiles,
                  allMails, //sendtoEmail,
                  "Yes"
                );
                allActivityLogs.push(activityTemp);
                // updateCurrentSequence();
              } else if (rejectedSubmit == "Yes") {
                let activityTemp =await ActivityService.getActivity(
                  "Request Edited",
                  placeholders,
                  " ",
                  "",
                  allMails, //sendtoEmail,
                  "Yes"
                );
                allActivityLogs.push(activityTemp);
                let activityTemp1 =await ActivityService.getActivity(
                  "Request Submitted",
                  placeholders,
                  data()?.remark || " ",
                  allAttachementFiles,
                  allMails, //sendtoEmail,
                  "Yes"
                );
                allActivityLogs.push(activityTemp1);
              } else {
                let activityTemp =await ActivityService.getActivity(
                  "Request Edited",
                  placeholders,
                  data()?.remark != null ? data()?.remark : " ",
                  allAttachementFiles,
                  allMails, //sendtoEmail,
                  "Yes"
                );
                allActivityLogs.push(activityTemp);
              }
            }
   
            let Organization_Name = new Set();
            let Counterparty_Type = new Set();
            let Country = new Set();
            let State = new Set();
            let City = new Set();
            let Zip_Code = new Set();
            let Address_Line_1 = new Set();
            let Address_Line_2 = new Set();
            let Contact_Number = new Set();
            let Email = new Set();
            let Counterparty_Jurisdiction = new Set();

            data()?.counterpartyname.forEach((c) => {
              Organization_Name.add(c.OrgName);
              Counterparty_Type.add(c.Counterpartyname);
              Country.add(c.Country);
              State.add(c.State);
              City.add(c.City);
              Zip_Code.add(c.ZipCode);
              Address_Line_1.add(c.Address_Line_1);
              Address_Line_2.add(c.Address_Line_2);
              Contact_Number.add(c.Contact_Number);
              Email.add(c.Email);
              Counterparty_Jurisdiction.add(c.OrganizationJurisdiction);
            });
            let finalcounter: any = {};
            //   console.log(Organization_Name,"Organization_Name")
            finalcounter.Organization_Name =
              Array.from(Organization_Name).join(", ");
            finalcounter.Counterparty_Type =
              Array.from(Counterparty_Type).join(", ");
            finalcounter.Country = Array.from(Country).join(", ");
            finalcounter.State = Array.from(State).join(", ");
            finalcounter.City = Array.from(City).join(", ");
            finalcounter.Zip_Code = Array.from(Zip_Code).join(", ");
            finalcounter.Address_Line_1 = Array.from(Address_Line_1).join(", ");
            finalcounter.Address_Line_2 = Array.from(Address_Line_2).join(", ");
            finalcounter.Contact_Number = Array.from(Contact_Number).join(", ");
            finalcounter.Email = Array.from(Email).join(", ");
            finalcounter.Counterparty_Jurisdiction = Array.from(
              Counterparty_Jurisdiction
            ).join(", ");
            // console.log(finalcounter,   "finalcounter")

            let _finalorgdetails = {
              Organization_Title: data()?.orgDetailsfinal[0]?.Organization_Title
                ? data()?.orgDetailsfinal[0]?.Organization_Title
                : "",
              Organization_URL: data()?.orgDetailsfinal[0]?.Organization_URL
                ? data()?.orgDetailsfinal[0]?.Organization_URL
                : "",
              Organization_Country: data()?.orgDetailsfinal[0]?.Organization_Country
                ? data()?.orgDetailsfinal[0]?.Organization_Country
                : "",
              Organization_Address_Line_1: data()?.orgDetailsfinal[0]
                ?.Organization_Address_Line_1
                ? data()?.orgDetailsfinal[0]?.Organization_Address_Line_1
                : "",
              Organization_Address_Line_2: data()?.orgDetailsfinal[0]
                ?.Organization_Address_Line_2
                ? data()?.orgDetailsfinal[0]?.Organization_Address_Line_2
                : "",
              Organization_City: data()?.orgDetailsfinal[0]?.Organization_City
                ? data()?.orgDetailsfinal[0]?.Organization_City
                : "",
              Organization_State: data()?.orgDetailsfinal[0]?.Organization_State
                ? data()?.orgDetailsfinal[0]?.Organization_State
                : "",
              Organization_ZipCode: data()?.orgDetailsfinal[0]?.Organization_ZipCode
                ? data()?.orgDetailsfinal[0]?.Organization_ZipCode
                : "",
              Organization_Website: data()?.orgDetailsfinal[0]?.Organization_Website
                ? data()?.orgDetailsfinal[0]?.Organization_Website
                : "",
              Organization_Currency: data()?.orgDetailsfinal[0]?.Organization_Currency
                ? data()?.orgDetailsfinal[0]?.Organization_Currency
                : "",
              Organization_Contact_Number: data()?.orgDetailsfinal[0]
                ?.Organization_Contact_Number
                ? data()?.orgDetailsfinal[0]?.Organization_Contact_Number
                : "",
              Organization_Jurisdiction: data()?.orgDetailsfinal[0]
                ?.Organization_Jurisdiction
                ? data()?.orgDetailsfinal[0]?.Organization_Jurisdiction
                : "",
            };
            AllfieldValues = {
              ...finalTemplate,
              ...finalcounter,
              ..._finalorgdetails,
            };
            // AllfieldValues = { ...finalTemplate };
            finalTemplate["Activity_Log"] = JSON.stringify(allActivityLogs);
            if (Errmessage == "A") {
              const token = localStorage.getItem("CurrentToken");
              //////console.log(finalTemplate, "finalTemplate");
              const updateurl =
                ContextService.GetUrl() +
                "/_api/web/lists/getbytitle('CLM365Request')/items('" +
                data()?.editid +
                "')";
              await axios
                .post(updateurl,finalTemplate, {
                  headers: {
                    Accept: "application/json;odata=nometadata",
                    "Content-type": "application/json;odata=nometadata",
                    "odata-version": "",
                    "IF-MATCH": "*",
                    "X-HTTP-Method": "MERGE",
                    Authorization: `Bearer ${token}`, 
                  }
                })  .then((response) => {
                  return response.data; // SharePoint's response JSON
                }).catch((error)=>{
                  console.log(error)
                })
              Contract_Request_Title = finalTemplate["Title"];
              hideDialogOptional();
              if (id != "Draft") {
                if (
                  ActivityDraft == "Draft" ||
                  (data()?.status == "Rejected" && rejectedSubmit == "Yes")
                ) {
                  if (taskJSON.length > 0) {
                    createTasksinbatch(
                      taskJSON,
                      placeholders,
                      guidid,
                      data()?.editid,
                      data()?.requestNumber != null ? data()?.requestNumber : RequestNumberSeq2,
                      placeholders,
                      Users,
                      allActivityLogs,
                      allMails,
                      data(),
                      Contract_Request_Title,
                    );
                  }
                }
              }
  
              if (
                data()?.drafttypelist != "Attach your own file" &&
                data()?.drafttypelist != "Blank"
              ) {
                //saverequestlistFile(fileName,finalTemplatelib)
                let finalTemp3 = {
                  TaskID: "",
                  File_Name: data()?.drafttypelist, //standardfileName,
                  File_Guid: "",
                  File_Content: data()?.selectedStandfile, //standardfileData,
                };
                allAttachementFiles.push(finalTemp3);
                await Updateformfieldvalues(
                  AllfieldValues,
                  data()?.selectedStandfile,
                  fileName,
                  finalTemplatelib,
                  data
                );
               
              }
              if (data()?.drafttypelist == "Attach your own file") {
                let finalTemp3 = {
                  TaskID: "",
                  File_Name: draftfiledata[0]?.name,
                  File_Guid: "",
                  File_Content: draftfiledata[0],
                };
                allAttachementFiles.push(finalTemp3);
                await Updateformfieldvalues(
                  AllfieldValues,
                  data()?.selectedthirdfile,
                  fileName,
                  finalTemplatelib,
                  data
                );
         
              }
              if (data()?.drafttypelist == "Blank") {
                deleteFile(data()?.doclibname);
              }
              if (ActivityDraft == "EditRequest" && id == "Pending") {
                
                Sweetalerteditrequest(
                  "success",
                  strings.SuccessmessagePostdata
                );
                setspinnerLoading(false)
              } else if (
                id == "Pending" &&
                ActivityDraft == "CommentsEditRequest"
              ) {
                SweetAlertEditCommentsrequest(
                  "success",
                  strings.SuccessmessagePostdata
                );
                setspinnerLoading(false)
              } else if (id == "Draft" || id == "Approved") {
                setspinnerLoading(false)
                SweetAlertEditDraft("success", strings.SuccessmessagePostdata);
              } else {

                setspinnerLoading(false)
                SweetAlertEditDraft("success", strings.SuccessmessagePostdata);
              }

              setTimeout(() => {
                setLoading(false);
                setspinnerLoading(false);
                props.handleHome()
                ResetFields();
                setButtonSaveText(strings.Save);
                // props.closepanel();
                // if (props.getdata != undefined) {
                //   props.getdata(data()?.currentbusUnitName, data()?.currentContractName);
                // }
                // if (props.setrefetch) {
                //   props?.setRefetch((c) => c + 1);
                // }
                // if (props.getRequesterDetails != undefined) {
                //   props.getRequesterDetails(props.commentsID);
                // }
                // setSaved(false);
              }, 3000);
            }
          }
        })
        .catch((err) => {
          if (ActivityDraft == "EditRequest") {
            Sweetalerteditrequest("error", err.errors[0]);
          } else if (ActivityDraft == "CommentsEditRequest") {
            SweetAlertEditCommentsrequest("error", err.errors[0]);
          } else {
            SweetAlertEditDraft("error", err.errors[0]);
          }
          setspinnerLoading(false)
        });
    } else {
      setspinnerLoading(false)
      SweetAlertEditDraft("error", strings.Enterremark);
    }

  }

  function openDialogRemark() {
    let requesterdraft1;
    setspinnerLoading(true)
    let RequestApproval;
    // if(status== "Rejected"){
    //   setRejectedSubmit("Yes");
    // }drafttypelist == "Standard Template"
    if (data()?.drafttypelist != "Attach your own file" && data()?.drafttypelist != "Blank") {
      if (data()?.standardtemp) {
        requesterdraft1 = data()?.drafttypelist; //standardtemp
      } else {
        requesterdraft1 = data()?.standardfile;
      }
      // requesterdraft = standardfile;
    } else if (data()?.drafttypelist == "Attach your own file") {
      // requesterdraft=attachFile1; //
      if (data()?.attachfile?.length > 0) {
        requesterdraft1 =
          data()?.attachfile[0][0].props.children[1].props.children?.props?.children ||
          data()?.attachfile[0][0].props.children[1].props.children;
      } else {
        if (ActivityDraft == "EditRequest") {
          setspinnerLoading(false)
          Sweetalerteditrequest("error", `${strings.Pleaseattachfile}`);
        } else if (ActivityDraft == "CommentsEditRequest") {
          setspinnerLoading(false)
          SweetAlertEditCommentsrequest("error", `${strings.Pleaseattachfile}`);
        } else {
          setspinnerLoading(false)
          SweetAlertEditDraft("error", `${strings.Pleaseattachfile}`);
        }
      }
    }

    if (
      (requesterdraft1 != null && requesterdraft1 != undefined) ||
      data()?.drafttypelist == "Blank"
    ) {
      let validationdata = data()?.validatestate 
      // if (selectedChoiceKey == "Indefinite") {
      if (data()?.selectedTerm == "Indefinite") {
        delete validationdata["Contract_End_Date"];
      }
      if (data()?.counterpartyname.length) {
        delete validationdata["Counterparty_Name"];
      } 
      ////console.log(validationdata, "validationdata")
      ////console.log(validatestate, "validatestate");
      let validationSchema = yup.object(validationdata);
      validationSchema
        .validate({
          ...dataText,
          ...dataNumber,
          ...dataNote,
          ...dateDatepicker,
          ...dataChoice2,
          ...attachmentFileData,
          ...documentTypesData,
          Contract_Cost: ContractCostData?.selectedAmount
        })
        .then(async () => {
          setspinnerLoading(true)
          setLoading(true);
          setButtonSaveText1("");
          let approvalStage = "Business Approval";
          let approvaldataontype = [];
          const requestApprovalData = data()?.allApprovalData?.filter((ele) => {
          if (ele.ApprovalStage === "Request Approval") {
            const matchingContractType = ele.Contracttype?.filter((item) => {
              return (
                item.guid === data()?.contracttypeId?.split("|")[1] ||
                item.key === "All"
              );
            });

            const matchingBusinessUnit = ele.BusinessUnit?.filter((item) => {
              return item.guid === data()?.businessunitdropvalue || item.key === "All";
            });

            const selectedCounterParty = data()?.counterpartyname?.map(e => e?.key) || [];
            const matchingCounterparty = ele?.Counterparty?.filter(item =>
              selectedCounterParty.includes(item?.key) || item.key === "All"
            );

            const matchingDepartment = ele.Department?.filter((item) => {
              return (
                item.code === DepartmentDetails().SelectedDepartment["code"] ||
                item.key === "All"
              );
            });

            return (
              matchingContractType?.length > 0 &&
              matchingCounterparty?.length > 0 &&
              (matchingBusinessUnit?.length > 0 ||
                (BusinessUnit === "No" && matchingBusinessUnit?.length === 0)) &&
              (matchingDepartment?.length > 0 ||
                (Department !== "Yes" && matchingDepartment?.length === 0))
            );
          }
          return false;
        });

          if (requestApprovalData?.length > 0) {
            businessData = requestApprovalData[requestApprovalData.length - 1]
          } else if (!requestApprovalData?.length) {
            const DefaultData = allApprovalData?.filter((ele) => ele?.DefaultFlow == "Yes")
            businessData = DefaultData.length ? DefaultData[0] : {}
          }
          let ActualFieldValue = "";
          let condtionsReturns = [];
          let SkipLevel2Index = 1
          let AutoApproveStatus = false;
          let skiplevel1 = false;
          let skiplevel2andmore = false;
          let SkipLevel2Stage = ""
          let approverData = "";
          taskJSON = [];
          let previousStepApproved = false;
          let legalUserId = [];
          var id = "Publish";
          let approvalInfo = [];
          setApprovalInfo([]);
          isOptional = false;
          RequestApproval = "Pending";
          DraftApproval = "Not Started";
          approvaldataontype = businessData ? [businessData]: [];
          if (approvaldataontype.length != 0 && Object.keys(approvaldataontype[0]).length !== 0) {
            // await Promise.all(approvaldataontype.map(async (item, index) => {
            for (let index = 0; index < approvaldataontype.length; index++) {
              const item = approvaldataontype[index];

              if (!AutoApproveStatus) {
                condtionsReturns = [];
                // approvalInfo = [];
                setApprovalInfo([]);
                taskJSON = [];
                for (
                  var i = 1;
                  i <= Object.keys(item.ApprovalLevel).length;
                  i++
                ) {
                  approverData = item.ApprovalLevel[i]["Approvers"];
                  let DocumentTypeFields =
                    item?.ApprovalLevel[i]["DocumentTypeFields"];
                  AutoApproveStatus = false;
                  skiplevel1 = false;
                  if(SkipLevel2Stage !== item.ApprovalLevel[i].Title){
                    skiplevel2andmore = false
                  }
                  legalUserId = [];
                  item.ApprovalLevel[i]?.["Conditions"]?.length && item.ApprovalLevel[i]?.["Conditions"]?.map((ele)=>{
                  if (ele?.["type"] =="Auto Approve" && !skiplevel2andmore) {
                    ele?.["ContractField"]?.forEach((currentCond) => {
                      let MainOperator = currentCond.Condition
                        ? currentCond.Condition
                        : "";
                      let currentType = "Text";
                      if (dataText[currentCond.FieldInternalName]) {
                        ActualFieldValue =
                          dataText[currentCond.FieldInternalName];
                        currentType = "Text";
                      } else if (
                        dateDatepicker[currentCond.FieldInternalName]
                      ) {
                        ActualFieldValue =
                          dateDatepicker[currentCond.FieldInternalName];
                        currentType = "Date";
                      }
                      ActualFieldValue=currentCond.FieldInternalName=="Contract_Cost"?ContractCostData?.selectedAmount:ActualFieldValue
                      const counterPartyNames = data()?.counterpartyname.length ? data()?.counterpartyname.map(item=>item.OrgName) : []
                      ActualFieldValue=currentCond.FieldInternalName=="Counterparty_Name"? counterPartyNames.includes(currentCond?.FieldValue) ? currentCond?.FieldValue : ActualFieldValue : ActualFieldValue
                      condtionsReturns = []
                      condtionsReturns.push(
                        validateApproval(
                          currentType,
                          ActualFieldValue,
                          currentCond.Operator,
                          currentCond.FieldValue
                        )
                      );
                      if (MainOperator != "") {
                        switch (MainOperator) {
                          case "and":
                            if (
                              // condtionsReturns[condtionsReturns.length - 2] &&
                              // condtionsReturns[condtionsReturns.length - 1]
                              AutoApproveStatus && condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1]
                            ) {
                              condtionsReturns = [];
                              AutoApproveStatus = true;
                            } else {
                              condtionsReturns = [];
                              AutoApproveStatus = false;
                            }

                            break;
                          case "or":
                            if (
                              // condtionsReturns[condtionsReturns.length - 2] ||
                              // condtionsReturns[condtionsReturns.length - 1]
                              AutoApproveStatus || (condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1])
                            ) {
                              condtionsReturns = [];
                              AutoApproveStatus = true;
                            } else {
                              condtionsReturns = [];
                              AutoApproveStatus = false;
                            }
                            break;
                        }
                      } else {
                        AutoApproveStatus = condtionsReturns.every(
                          (item) => item === true
                        )
                          ? true
                          : false;
                      }
                    });
                  } else if (ele?.["type"] == "Skip L1" && !skiplevel2andmore) {
                    ele?.["ContractField"].forEach((currentCond) => {
                      if (!skiplevel1) {
                        let MainOperator = currentCond.Condition
                          ? currentCond.Condition
                          : "";
                        let currentType = "Text";
                        if (dataText[currentCond.FieldInternalName]) {
                          ActualFieldValue =
                            dataText[currentCond.FieldInternalName];
                          currentType = "Text";
                        } else if (
                          dateDatepicker[currentCond.FieldInternalName]
                        ) {
                          ActualFieldValue =
                            dateDatepicker[currentCond.FieldInternalName];
                          currentType = "Date";
                        }
                         ActualFieldValue=currentCond.FieldInternalName=="Contract_Cost"?ContractCostData?.selectedAmount:ActualFieldValue
                        const counterPartyNames = data()?.counterpartyname.length ? data()?.counterpartyname.map(item=>item.OrgName) : []
                        ActualFieldValue=currentCond.FieldInternalName=="Counterparty_Name"? counterPartyNames.includes(currentCond?.FieldValue) ? currentCond?.FieldValue : ActualFieldValue : ActualFieldValue
                        condtionsReturns = []
             
                        condtionsReturns.push(
                          validateApproval(
                            currentType,
                            ActualFieldValue,
                            currentCond.Operator,
                            currentCond.FieldValue
                          )
                        );
                        if (MainOperator != "")
                          switch (MainOperator) {
                            case "and":
                              if (
                                // condtionsReturns[condtionsReturns.length - 2] &&
                                // condtionsReturns[condtionsReturns.length - 1]
                                skiplevel1 && condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1]
                              ) {
                                condtionsReturns = [];
                                skiplevel1 = true;
                              } else {
                                condtionsReturns = [];
                                skiplevel1 = false;
                              }

                              break;
                            case "or":
                              if (
                                // condtionsReturns[condtionsReturns.length - 2] ||
                                // condtionsReturns[condtionsReturns.length - 1]
                                skiplevel1 || (condtionsReturns?.length && condtionsReturns[condtionsReturns.length - 1])
                              ) {
                                condtionsReturns = [];
                                skiplevel1 = true;
                              } else {
                                condtionsReturns = [];
                                skiplevel1 = false;
                              }
                              break;
                          }
                      }
                    });
                  } 
                  if (ele?.["type"] == "Skip L2 & more" && !skiplevel2andmore) {
                    ele?.["ContractField"].forEach((currentCond) => {
                      if (!skiplevel2andmore) {
                        let MainOperator = currentCond.Condition
                          ? currentCond.Condition
                          : "";
                        let currentType = "Text";
                        if (dataText[currentCond.FieldInternalName]) {
                          ActualFieldValue =
                            dataText[currentCond.FieldInternalName];
                          currentType = "Text";
                        } else if (
                          dateDatepicker[currentCond.FieldInternalName]
                        ) {
                          ActualFieldValue =
                            dateDatepicker[currentCond.FieldInternalName];
                          currentType = "Date";
                        }
                        ActualFieldValue=currentCond.FieldInternalName=="Contract_Cost"?ContractCostData?.selectedAmount:ActualFieldValue
                        const counterPartyNames = data()?.counterpartyname.length ? data()?.counterpartyname.map(item=>item.OrgName) : []
                        ActualFieldValue=currentCond.FieldInternalName=="Counterparty_Name"? counterPartyNames.includes(currentCond?.FieldValue) ? currentCond?.FieldValue : ActualFieldValue : ActualFieldValue
                        //ActualFieldValue = dataText[currentCond.FieldInternalName] ? dataText[currentCond.FieldInternalName] : (dateDatepicker[currentCond.FieldInternalName] ? dateDatepicker[currentCond.FieldInternalName] : "" )
                        condtionsReturns = []
                        condtionsReturns.push(
                          validateApproval(
                            currentType,
                            ActualFieldValue,
                            currentCond.Operator,
                            currentCond.FieldValue
                          )
                        );
                        if (MainOperator != "")
                          switch (MainOperator) {
                            case "and":
                              if (
                                condtionsReturns[condtionsReturns.length - 2] &&
                                condtionsReturns[condtionsReturns.length - 1]
                              ) {
                                condtionsReturns = [];
                                skiplevel2andmore = true;
                              } else {
                                condtionsReturns = [];
                                skiplevel2andmore = false;
                              }

                              break;
                            case "or":
                              if (
                                condtionsReturns[condtionsReturns.length - 2] ||
                                condtionsReturns[condtionsReturns.length - 1]
                              ) {
                                condtionsReturns = [];
                                skiplevel2andmore = true;
                              } else {
                                condtionsReturns = [];
                                skiplevel2andmore = false;
                              }
                              break;
                          }else{
                              skiplevel2andmore = condtionsReturns.every(
                                (item) => item === true
                              )
                                ? true
                                : false;
                              if(skiplevel2andmore) {
                                SkipLevel2Stage = item.ApprovalLevel[i]?.TaskTitle
                                SkipLevel2Index = i
                              }
                        }
                      }
                    });
                  }
                })
                  let approvedByEmail = [];
                  let approvedByIds = [];
                  let approvedByName = [];

                  let userswithselectedrole;
                  // console.log(ContextService.GetCurrentUser());
                  let currentUserInfo = Users?.filter((item) => {
                    return item.Id ===  props?.currentUser.currentUserId;
                  });
                  if (currentUserInfo?.[0]?.Manager?.EMail) {
                    let checkuserexists = Users?.filter((item) => {
                      return item.Id === currentUserInfo?.[0]?.Manager?.ID;
                    });
                    if (checkuserexists.length > 0) {
                      businessuserManager = currentUserInfo?.[0]?.Manager;
                      let currentManagerInfo = Users?.filter((item) => {
                        return item.Id === businessuserManager?.ID;
                      });
                      if (currentManagerInfo?.[0]?.Manager?.EMail) {
                        let checkexists = Users?.filter((item) => {
                          return (
                            item.Id === currentManagerInfo?.[0]?.Manager?.ID
                          );
                        });
                        if (checkexists.length > 0) {
                          businessuserManagerManger =
                            currentManagerInfo?.[0]?.Manager;
                        }
                      }
                    }
                  }
                  let jobTitleval = approverData?.[0]?.["role"]
                    ? approverData?.[0]?.["role"]
                    : "";
                  if (jobTitleval) {
                    userswithselectedrole = Users?.filter((item) => {
                      return item.Role === jobTitleval;
                    });
                  }

                  let approvedbyAll = "No";
                  let checkedApprovers = [];
                  if (item.ApprovalLevel[i]?.["Title"] == "Legal Review") {
                    if (approverData?.[0]?.["checkEmpName"]) {
                      approvedByEmail = approverData?.[0]?.["approveremail"]
                        ? approverData?.[0]?.["approveremail"]
                        : [];

                      approvedByIds = approverData?.[0]?.["approverid"]
                        ? approverData?.[0]?.["approverid"]
                        : [];

                      approvedByName = approverData?.[0]?.["approverName"]
                        ? approverData?.[0]?.["approverName"]?.[0]
                        : [];
                      workflowempapproversemail = approvedByEmail;
                      workflowempapproversids = approvedByIds;
                      workflowempapproversname = approvedByName;
                      checkedApprovers.push("EmployeeName");
                      approvedByIds?.forEach((useriD) => {
                        legalUserId.push(useriD);
                      });
                    }
                    if (
                      approverData?.[0]?.["checkEmpManager"] &&
                      businessuserManager?.EMail
                    ) {
                      legalUserId.push(businessuserManager?.ID);
                      approvedByEmail.push(businessuserManager?.EMail);
                      approvedByName.push(businessuserManager?.Title);
                      checkedApprovers.push("EmployeeManager");
                    }
                    if (
                      approverData?.[0]?.["checkEmpManagersManager"] &&
                      businessuserManagerManger?.EMail
                    ) {
                      legalUserId.push(businessuserManagerManger?.ID);
                      approvedByEmail.push(businessuserManagerManger?.EMail);
                      approvedByName.push(businessuserManagerManger?.Title);
                      checkedApprovers.push("EmployeeManagersManager");
                    }
                    if (approverData?.[0]?.["checkJobTitle"]) {
                      userswithselectedrole?.forEach((ele) => {
                        legalUserId.push(ele.Id);
                        approvedByEmail.push(ele?.email);
                        approvedByName.push(ele?.text);
                      });
                      checkedApprovers.push("Role");
                    }
                    approvedByIds = legalUserId;
                  } else {
                    if (approverData?.[0]?.["checkEmpName"]) {
                      approvedByEmail = approverData?.[0]?.["approveremail"]
                        ? approverData?.[0]?.["approveremail"]
                        : [];

                      approvedByIds = approverData?.[0]?.["approverid"]
                        ? approverData?.[0]?.["approverid"]
                        : [];

                      approvedByName = approverData?.[0]?.["approverName"]
                        ? approverData?.[0]?.["approverName"]
                        : [];
                      checkedApprovers.push("EmployeeName");
                    }
                    if (
                      approverData?.[0]?.["checkEmpManager"] &&
                      businessuserManager.EMail
                    ) {
                      approvedByIds.push(businessuserManager.ID);
                      approvedByEmail.push(businessuserManager.EMail);
                      approvedByName.push(businessuserManager.Title);
                      checkedApprovers.push("EmployeeManager");
                    }
                    if (
                      approverData?.[0]?.["checkEmpManagersManager"] &&
                      businessuserManagerManger?.EMail
                    ) {
                      approvedByIds.push(businessuserManagerManger.ID);
                      approvedByEmail.push(businessuserManagerManger.EMail);
                      approvedByName.push(businessuserManagerManger.Title);
                      checkedApprovers.push("EmployeeManagersManager");
                    }
                    if (approverData?.[0]?.["checkJobTitle"]) {
                      userswithselectedrole?.forEach((ele) => {
                        approvedByIds.push(ele.Id);
                        approvedByEmail.push(ele?.email);
                        approvedByName.push(ele?.text);
                      });
                      checkedApprovers.push("Role");
                    }
                  }

                  if (item.ApprovalLevel[i]?.["AllorAny"] == "All") {
                    approvedbyAll = "Yes";
                  }
                  approvedByIds =
                    approvedByIds?.length > 0 ? approvedByIds : null;

                  let taskDueDate = new Date();
                  // taskDueDate.setDate(
                  //   taskDueDate.getDate() +
                  //     parseInt(item.ApprovalLevel[i]?.["DueDays"])
                  // );
                  if (item.ApprovalLevel[i]?.DaysType === 'Business days'){
                    taskDueDate = CalcuateBusinessDays(item.ApprovalLevel[i].DueDays,item.ApprovalLevel[i].Days);
                  } else{
                  taskDueDate.setDate(
                    taskDueDate.getDate() +
                      parseInt(item.ApprovalLevel[i]?.["DueDays"])
                  );
                  }
                  if (AutoApproveStatus) {
                    let taskCreated = false;
                    let taskguidid =uuid().toString();
                    id = id == "Pending" ? id : (id = "Approved");
                    if (i == 1 || previousStepApproved) {
                      // taskJSON.push({
                      //   TaskName: item.ApprovalLevel[i]?.["Title"],
                      //   TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                      //     ? item.ApprovalLevel[i]?.["TaskTitle"]
                      //     : item.ApprovalLevel[i]?.["Title"],
                      //   RequestType: data()?.requesttypevalue,
                      //   BusinessUnit: data()?.businessunitdropvalue,
                      //   ContractType: data()?.contracttypeId,
                      //   Status: "Completed",
                      //   TaskGudId: taskguidid,
                      //   LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                      //   AssignedToId:
                      //     approvedByIds?.length > 0 ? approvedByIds : [],
                      //   AssignedToEmail:
                      //     approvedByEmail?.length > 0 ? approvedByEmail : [],
                      //   DueDate: taskDueDate,
                      //   OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                      //   DueDays: item.ApprovalLevel[i]?.["DueDays"],
                      //   EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                      //   HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                      //   DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                      //   Optional: item.ApprovalLevel[i]?.["Optional"],
                      //   ApproverName: approvedByName ? approvedByName : [],
                      //   Mandatory: true,
                      // });
                      taskCreated = true;
                      previousStepApproved = true;
                    }
                    approvalInfo.push({
                      Level: "Level" + i,
                      ApprovedByAll: approvedbyAll,
                      DocumentTypeFields: DocumentTypeFields,
                      AutoApprove: "Yes",
                      Skipped: "No",
                      ApprovalFlow: item.WorkflowId,
                      EmpName: approverData?.[0]?.["checkEmpName"],
                      EmpManager: approverData?.[0]?.["checkEmpManager"],
                      EmpManagersManager:
                        approverData?.[0]?.["checkEmpManagersManager"],
                      JobTitle: approverData?.[0]?.["checkJobTitle"],
                      ManualApproveReq: previousStepApproved ? "No" : "Yes",
                      TaskApprovedDate: previousStepApproved ? new Date() : "",
                      TaskAssignedToRole: jobTitleval,
                      TaskGudId: taskguidid,
                      taskCreated: taskCreated,
                      TaskData: JSON.stringify({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType:data()?. requesttypevalue,
                        BusinessUnit: data()?.businessunitdropvalue,
                        ContractType: data()?.contracttypeId,
                        TaskGudId: taskguidid,
                        // OnPreviousLvLApproval: previousStepApproved
                        //   ? "Approved"
                        //   : "AutoAppprove", //Auto Approved for the if the task step get manual approved then this task should get approved immediately as its autoapproved
                        OnPreviousLvLApproval: "AutoAppprove",
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId:
                          approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail:
                          approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        // Status: previousStepApproved
                        //   ? "Completed"
                        //   : "Not Started",
                        Status: "Completed",
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        ApproverName: approvedByName ? approvedByName : [],
                        Mandatory: true,
                      }),
                    });
                  } else if (skiplevel1) {
                    id = id == "Pending" ? id : (id = "Approved");
                    if (i == 1) {
                      previousStepApproved = true;
                    }
                    let taskguidid = uuid().toString();
                    approvalInfo.push({
                      Level: "Level" + i,
                      ApprovedByAll: approvedbyAll,
                      DocumentTypeFields: DocumentTypeFields,
                      AutoApprove: "No",
                      Skipped: "Yes",
                      ApprovalFlow: item.WorkflowId,
                      EmpName: approverData?.[0]?.["checkEmpName"],
                      EmpManager: approverData?.[0]?.["checkEmpManager"],
                      EmpManagersManager:
                        approverData?.[0]?.["checkEmpManagersManager"],
                      JobTitle: approverData?.[0]?.["checkJobTitle"],
                      ManualApproveReq: "No",
                      TaskApprovedDate: new Date(),
                      TaskAssignedToRole: jobTitleval,
                      TaskGudId: taskguidid,
                      taskCreated: false,
                      TaskData: JSON.stringify({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType: data()?.requesttypevalue,
                        BusinessUnit:data()?. businessunitdropvalue,
                        ContractType: data()?.contracttypeId,
                        TaskGudId: taskguidid,
                        OnPreviousLvLApproval: previousStepApproved
                          ? "Approved"
                          : "AutoSkipped", //Auto Approved for the if the task step get manual approved then this task should get approved immediately as its autoSkipped
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId:
                          approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail:
                          approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        Status: previousStepApproved
                          ? "Completed"
                          : "Not Started",
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        Mandatory: true,
                      }),
                    });
                  } else if (skiplevel2andmore && SkipLevel2Stage == item.ApprovalLevel[i].Title && i>SkipLevel2Index) {
                    id = id == "Pending" ? id : (id = "Approved");

                    if (i >= 2) {
                      previousStepApproved = true;
                    }
                    let taskguidid = uuid().toString();
                    approvalInfo.push({
                      Level: "Level" + i,
                      ApprovedByAll: approvedbyAll,
                      DocumentTypeFields: DocumentTypeFields,
                      AutoApprove: "No",
                      Skipped: "Yes",
                      ApprovalFlow: item.WorkflowId,
                      EmpName: approverData?.[0]?.["checkEmpName"],
                      EmpManager: approverData?.[0]?.["checkEmpManager"],
                      EmpManagersManager:
                        approverData?.[0]?.["checkEmpManagersManager"],
                      JobTitle: approverData?.[0]?.["checkJobTitle"],
                      ManualApproveReq: "No",
                      TaskApprovedDate: new Date(),
                      TaskAssignedToRole: jobTitleval,
                      TaskGudId: taskguidid,
                      taskCreated: false,
                      TaskData: JSON.stringify({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType: data()?.requesttypevalue,
                        BusinessUnit:data()?. businessunitdropvalue,
                        ContractType: data()?.contracttypeId,
                        TaskGudId: taskguidid,
                        OnPreviousLvLApproval: previousStepApproved
                          ? "Approved"
                          : "AutoSkipped", //Auto Approved for the if the task step get manual approved then this task should get approved immediately as its autoSkipped
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId:
                          approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail:
                          approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        Status: previousStepApproved
                          ? "Completed"
                          : "Not Started",
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        ApproverName: approvedByName ? approvedByName : "",
                        Mandatory: true,
                      }),
                    });
                  } else {
                    id = "Pending";
                    let skippedflag = "No";
                    if (i >= 2 && skiplevel2andmore) {
                      id = "Approved";
                      skippedflag = "Yes";
                    }
                    let taskCreated = false;
                    let taskguidid = uuid().toString();
                    if (i == 1 && !skiplevel1) {
                      // taskJSON.push({
                      //   TaskName: item.ApprovalLevel[i]?.["Title"],
                      //   TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                      //     ? item.ApprovalLevel[i]?.["TaskTitle"]
                      //     : item.ApprovalLevel[i]?.["Title"],
                      //   RequestType: data()?.requesttypevalue,
                      //   BusinessUnit: data()?.businessunitdropvalue,
                      //   ContractType: data()?.contracttypeId,
                      //   TaskGudId: taskguidid,
                      //   Status: "Not Started",
                      //   LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                      //   AssignedToId:
                      //     approvedByIds?.length > 0 ? approvedByIds : [],
                      //   AssignedToEmail:
                      //     approvedByEmail?.length > 0 ? approvedByEmail : [],
                      //   DueDate: taskDueDate,
                      //   OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                      //   DueDays: item.ApprovalLevel[i]?.["DueDays"],
                      //   EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                      //   HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                      //   DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                      //   Optional: item.ApprovalLevel[i]?.["Optional"],
                      //   ApproverName: approvedByName ? approvedByName : "",
                      //   Mandatory: true,
                      // });
                      taskCreated = true;
                    } else if (previousStepApproved && skippedflag != "Yes") {
                      // taskJSON.push({
                      //   TaskName: item.ApprovalLevel[i]?.["Title"],
                      //   TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                      //     ? item.ApprovalLevel[i]?.["TaskTitle"]
                      //     : item.ApprovalLevel[i]?.["Title"],
                      //   RequestType: data()?.requesttypevalue,
                      //   BusinessUnit:data()?. businessunitdropvalue,
                      //   ContractType: data()?.contracttypeId,
                      //   TaskGudId: taskguidid,
                      //   Status: "Not Started",
                      //   LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                      //   AssignedToId:
                      //     approvedByIds?.length > 0 ? approvedByIds : [],
                      //   AssignedToEmail:
                      //     approvedByEmail?.length > 0 ? approvedByEmail : [],
                      //   DueDate: taskDueDate,
                      //   OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                      //   DueDays: item.ApprovalLevel[i]?.["DueDays"],
                      //   EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                      //   HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                      //   DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                      //   Optional: item.ApprovalLevel[i]?.["Optional"],
                      //   ApproverName: approvedByName ? approvedByName : "",
                      //   Mandatory: true,
                      // });
                      taskCreated = true;
                    }
                    if (item.ApprovalLevel[i]?.["Optional"]) {
                      isOptional = true;
                    }
                    approvalInfo.push({
                      Level: "Level" + i,
                      ApprovedByAll: approvedbyAll,
                      DocumentTypeFields: DocumentTypeFields,
                      AutoApprove: "No",
                      Skipped: "No",
                      ApprovalFlow: item.WorkflowId,
                      EmpName: approverData?.[0]?.["checkEmpName"],
                      EmpManager: approverData?.[0]?.["checkEmpManager"],
                      EmpManagersManager:
                        approverData?.[0]?.["checkEmpManagersManager"],
                      JobTitle: approverData?.[0]?.["checkJobTitle"],
                      ManualApproveReq: previousStepApproved ? "No" : "Yes",
                      TaskApprovedDate: previousStepApproved ? new Date() : "",
                      TaskAssignedToRole: jobTitleval,
                      TaskGudId: taskguidid,
                      taskCreated: taskCreated,
                      LegalUserId: legalUserId?.length > 0 ? legalUserId : null,
                      TaskData: JSON.stringify({
                        TaskName: item.ApprovalLevel[i]?.["Title"],
                        TaskTitle: item.ApprovalLevel[i]?.["TaskTitle"]
                          ? item.ApprovalLevel[i]?.["TaskTitle"]
                          : item.ApprovalLevel[i]?.["Title"],
                        RequestType: data()?.requesttypevalue,
                        BusinessUnit:data()?. businessunitdropvalue,
                        ContractType:data()?. contracttypeId,
                        TaskGudId: taskguidid,
                        OnPreviousLvLApproval: previousStepApproved
                          ? "Approved"
                          : "AutoAppprove", //Auto Approved for the if the task step get manual approved then this task should get approved immediately as its autoapproved
                        LegalUserId: legalUserId?.length > 0 ? legalUserId : [],
                        AssignedToId:
                          approvedByIds?.length > 0 ? approvedByIds : [],
                        AssignedToEmail:
                          approvedByEmail?.length > 0 ? approvedByEmail : [],
                        DueDate: taskDueDate,
                        Status: previousStepApproved
                          ? "Completed"
                          : "Not Started",
                        OnRejection: item.ApprovalLevel[i]?.["OnRejection"],
                        DueDays: item.ApprovalLevel[i]?.["DueDays"],
                        EditCheck: item.ApprovalLevel[i]?.["EditCheck"],
                        HoldCheck: item.ApprovalLevel[i]?.["HoldCheck"],
                        DraftUpload: item.ApprovalLevel[i]?.["DraftUpload"],
                        Optional: item.ApprovalLevel[i]?.["Optional"],
                        Mandatory: true,
                        ApproverName: approvedByName ? approvedByName : "",
                      }),
                    });
                    previousStepApproved = false;
                  }
                }
              }
            }
          } else {
            RequestApproval = "Completed";
          }

          setApprovalInfo(approvalInfo);
          if (isOptional) {
            setspinnerLoading(false)
            // getroledata();
            // setloadApprovalsInfos(true);
            showDialogOptional();
            setLoading(false);
            // setSubmitDisabled(false);
            setButtonSaveText1(strings.UpdateSubmit);
          } else {
          
            // showremarkDialog();
            PostContractformdata("Publish", approvalInfo);
            setLoading(false);
            // setSubmitDisabled(false);
            setButtonSaveText1(
              data()?.status == "Rejected" ? strings.Submit : strings.UpdateSubmit
            );
          }
    })
        .catch((err) => {
          setspinnerLoading(false)
          if (ActivityDraft == "EditRequest") {
            Sweetalerteditrequest("error", err.errors[0]);
          } else if (ActivityDraft == "CommentsEditRequest") {
            SweetAlertEditCommentsrequest("error", err.errors[0]);
          } else {
            SweetAlertEditDraft("error", err.errors[0]);
          }

        });
    } else {
      setspinnerLoading(false)
      // seterrormsgAttach(true);
      // setTimeout(() => {
      //   seterrormsgAttach(false);
      // }, 3000);
    }
  }

  function ResetFields() {

    setData((c)=>({
      ...c,
      attachremarkFile1:[],
      attachremarkFile2:[]
    }))
    remarksetatt1 = [];
    remarksetatt = [];
  }


  const handleTermCallback = (count, term) => {
    // alert("term func")
    const validTerms = ["Day", "Week", "Month", "Year"];
    // const validTerms = ["Year","Month","Week","Day"]  
    //if(!validTerms.includes(term)){
    // console.log("Term is invalid");

    //  setdateDatepicker((c) => ({ ...c, "Contract_End_Date": "" }));

    //  setTermPeriodObj({ count: "", term });

    // return;
    // }
    if (data()?.selectedTerm == "Indefinite") {
      setData((c) => ({
        ...c,
        selectedChoiceKey: "Indefinite",
        isDisabled:true
      }));
      // setselectedChoiceKey("Indefinite")
      // setIsDisabled(true);
      setIsTermDialogvisible(false);
    } else {
      let res: any = moment(dateDatepicker["Contract_Start_Date"]).add(
        count,
        term.toLowerCase()
      ).subtract(1, 'days');
      setData((c) => ({
        ...c,
        termObj:{ count, term },
        showDurationTextField:false
      }));
      // setTermObj({ count, term });
      setIsTermDialogvisible(false);
      setdateDatepicker((c) => ({
        ...c,
        ...{ Contract_End_Date: new Date(res) },
      }));
      // setdateDatepicker()
      //const dateString = new Date(res).toLocaleDateString();  
      // setTermTextFieldValue(dateString)
      // setShowDurationTextField(false);
    }
    console.log(dateDatepicker);
  };
  const handleTermChange = (term) => {
    // setSelectedTerm(term); 
    setData((c) => ({
      ...c,
      selectedTerm:term
    }));
  };

  return (
    <div id="Sweetalerteditrequest">

{spinnerLoading || !allRequestOpt?.length && <div style={{position:'absolute',top:'50%',left:'30%'}}>
       
       <Spinner label="Please wait..." ariaLive="assertive" labelPosition="right" />
     </div>}
     {RequestLoading &&<div style={{position:'absolute',top:'50%',left:'30%'}}>
       
       <Spinner label="Please wait..." ariaLive="assertive" labelPosition="right" />
     </div>}
     <div style={{opacity:spinnerLoading || !allRequestOpt?.length ?'0.2':'1',pointerEvents:spinnerLoading || !allRequestOpt?.length ? "none":"auto"}} >


<div >
      <Label>Update Exisiting Request</Label>
     
      </div>

      <Select
        placeholder={"Select Request"}
        options={allRequestOpt}
        value={
          selectedRequest != undefined &&
          selectedRequest != null &&
          allRequestOpt?.filter(({ key }) => key === selectedRequest)
        }
        isSearchable={true}
        onChange={(select) => onChangeRequest(select)}
        styles={customStyles}
        theme={SelectTheme}
      />
      {selectedRequest && !RequestLoading && (
        <div>
          <div className={"addnewrequestersection"}>
            <div>
              <Label //style={{ marginRight: '5px' }}
                required
              >
                {strings.RequestType}
              </Label>
              <Dropdown
                // className={"labelstylemargin"}
                placeholder={strings.SelectRequestType}
                //options={contracttypename}
                options={requesttype}
                styles={dropdownStyles}
                disabled={true}
                //  onChange={onChangeRequesttype}
                selectedKey={data()?.requesttypevalue}
                //  onChange={onChangeDrafttype}
                // disabled={true}
              />
            </div>
            {(Department || "No") === "Yes" && <div>
              <Label required>{strings.Department}</Label>
              <Select
                placeholder={strings.SelectDepartment}
                options={DepartmentDetails().DepartmentOptions.sort((a, b) => a?.label?.localeCompare(b?.label))}
                onChange={(select) => onChangeDepartmentDetails(select)}
                value={(DepartmentDetails().SelectedDepartment) && DepartmentDetails().DepartmentOptions.filter(({ key }) => key === DepartmentDetails().SelectedDepartment["key"])}
                isSearchable={true}
                styles={props.ActivityDraft !== "Draft" && !!DepartmentDetails().SelectedDepartment ? selectDisabled : customStyles}
                isDisabled={props.ActivityDraft !== "Draft" && !!DepartmentDetails().SelectedDepartment}
              />
            </div>}
            {BusinessUnit == "Yes" ? (
              <div>
                <Label //style={{ marginRight: '5px' }}
                  required
                >
                  {strings.BusinessUnit}
                </Label>
                <Dropdown
                  placeholder={strings.SelectBusinessUnit}
                  options={data()?.BusinessunitOptions}
                  onChange={onchangebusinessunit}
                  disabled={true}
                  selectedKey={data()?.businessunitdropvalue}
                />
              </div>
            ) : (
              ""
            )}
            <div>
              <Label //style={{ marginRight: '5px' }}
                required
              >
                {strings.contracttypename}
              </Label>

              <Dropdown
                // className={"labelstylemargin"}
                placeholder={strings.Selcttype}
                options={optionConName}
                selectedKey={data()?.contracttypeselect}
                onChange={onChangeContractname}
                disabled={true}
              />
            </div>

            <div>
              <Label //style={{ marginRight: '5px' }}
                required
              >
                {/* {strings.DraftType} */}
                {"Select Template"}
              </Label>
              {/* <Dropdown
                // className={"labelstylemargin"}
                placeholder={strings.SelectDraftType}
                //options={contracttypename}
                options={data()?.draftTypeOptions} //drafttypeoption
                styles={dropdownStyles}
                selectedKey={data()?.drafttypelist}
                onChange={onChangeDrafttype}
                // disabled={true}
              /> */}
   <Select
              placeholder={'Select draft type'}
              options={data()?.draftTypeOptions}
              value={
                data()?.drafttypelist != undefined &&
                data()?.drafttypelist != null &&
                data()?.draftTypeOptions?.filter(({ key }) => key === data()?.drafttypelist)
              }
              // isDisabled={!Component12}
              isSearchable={true}
              theme={SelectTheme}
              onChange={(select) => onChangeDrafttype(select)}
              styles={customStyles}
              // menuIsOpen
            />

              {/* {(drafttypelist == "Standard Template") ? <>{standardfile}</> : null} */}
            </div>

            <div
              className="atch"
              style={{
                marginTop: BusinessUnit == "Yes" ? "0px" : "-16px",
              }}
            >
              {formfieldjson && data()?.drafttypelist == "Attach your own file" && !data()?.attachfile?.length ? (
                <>
             <div style={{display:'flex'}} 
            //  onClick={()=>{setAttachYourOwnFile(true)}}
             >
            <Label htmlFor="file-input"  
                //  onClick={()=>{setAttachYourOwnFile(true)}}
                 style={{ marginLeft: "6px", marginTop: "25px",display:'flex',cursor:'pointer' }}>
                 <Label htmlFor="file-input"  
                //  onClick={()=>{setAttachYourOwnFile(true)}}
                  required> Select a file</Label> 
                  {/* <div style={{display:'flex',gap:'5px',marginLeft:'-10px'}}> */}
                <Icon
                  iconName="Attach"
                  // onClick={()=>{setAttachYourOwnFile(true)}}
                  style={{ paddingTop:'7px',marginLeft:'-10px' }}//top-8px
                  styles={{
                    root: {
                      color:"var(--layoutIconColor)"
                    },
                  }}
                ></Icon>
                {/* className={"imgload"} */}
            
                {/* </div> */}
                </Label>
                <div className={"imgload"} >
                  <TooltipHost
                    content={strings.attachment}
                    id="field2"
                    styles={hostStyles}
                  >
                    <IconButton
                      id="field2"
                      aria-describedby="field2"
                      style={{ marginTop: "25px" }}
                      iconProps={{ iconName: "Info" }}
                      styles={{
                        icon: {
                          color:"var(--layoutIconColor)",
                        },
                      }}
                    ></IconButton>
                  </TooltipHost>
                </div>
             
            </div>
                 
                </>
              ) : data()?.drafttypelist == "Attach your own file" && data()?.attachfile?.length ? (
                <label htmlFor="file-input" style={{ display: "flex", width: "auto" }}>
                  {" "}
                  {data()?.attachfile}
                </label>
              ) : null}
            </div>
          </div>
          <div>
            {formfieldjson && data()?.drafttypelist == "Attach your own file" && !data()?.attachfile?.length ? (
              <>
                <DragAndDrop
                  showLabel={false}
                  onChangeAdd={onAttachmentChange1}
                  accept=".docx,.pdf,.doc"
                  selectedFile={data()?.attachfile}
                  key={JSON.stringify(data()?.attachfile)}
                />
              </>
            ) : null}
          </div>

          <div>
            {formfieldjson
              ? Object.entries(formfieldjson).map(([key1, column]: any, index: any) => {
                  ////////console.log(key1);
                  //  if (column.status == "Enable") {
                  return (
                    <>
                      <h3
                        style={{
                          marginBottom: "8px",
                          color: SettingService.GetTheme() == "dark" ? "#fff" : "#000",
                        }}
                      >
                        {key1}
                      </h3>
                      {key1 != "General" ? (
                        <div
                          style={{
                            borderBottom: "1.5px solid var(--lightdarkBGTable)",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            borderBottom: "1.5px solid var(--lightdarkBGTable)",
                          }}
                        />
                      )}

                      <div className={"addnewrequestersection"}>
                        {column.items.map((item: any, ind: any) => {
                          if (
                            item.Type == "Text" //&& item.Display == true
                          ) {
                            return (
                              <div id={item.IntName}>
                                <Label required={item.Required == "Yes" ? true : false}>
                                  {" "}
                                  {data()?.CurrentdisplayfieldsName[item.IntName]}
                                </Label>
                                <TextField
                                  id={item.IntName}
                                  name={item.text}
                                  value={dataText[item.IntName] || ""}
                                  placeholder={"Enter " + data()?.CurrentdisplayfieldsName[item.IntName]}
                                  onChange={gettextvalue}
                                ></TextField>
                              </div>
                            );
                          }
                          if (
                            item.Type == "Note" //&& item.Display == true
                          ) {
                            return (
                              <>
                                <div id={item.IntName}>
                                  <Label required={item.Required == "Yes" ? true : false}>
                                    {" "}
                                    {data()?.CurrentdisplayfieldsName[item.IntName]}
                                  </Label>
                                  <TextField
                                    id={item.IntName}
                                    name={item.text}
                                    value={dataNote[item.IntName] || ""}
                                    placeholder={"Enter " + data()?.CurrentdisplayfieldsName[item.IntName]}
                                    onChange={getnotevalue}
                                    multiline
                                  ></TextField>
                                </div>
                              </>
                            );
                          }
                          if (
                            item.Type == "Number" //&& item.Display == true
                          ) {
                            return (
                              <>
                                <div id={item.IntName}>
                                  <Label required={item.Required == "Yes" ? true : false}>
                                    {data()?.CurrentdisplayfieldsName[item.IntName]}
                                  </Label>
                                  <TextField
                                    id={item.IntName} //value={item.value}
                                    // value={item.value}
                                    value={dataNumber[item.IntName] || ""}
                                    placeholder={"Enter " + data()?.CurrentdisplayfieldsName[item.IntName]}
                                    //  name="value"
                                    type="Number"
                                    onChange={getnumbervalue}
                                  ></TextField>
                                </div>
                                {finalconditionNumber
                                  ? Object.entries(finalconditionNumber).map(([Outerkey, column]: any, index: any) => {
                                      if (item.IntName == Outerkey) {
                                        // ////console.log(column, "column")
                                        // return Object.entries(column).map(([Innerkey, innerfields]: any, index: any) => {
                                        return column.Fields.length
                                          ? column.Fields.map((choicefields) => {
                                              if (choicefields.type == "Text")
                                                return (
                                                  <div id={choicefields.InternalName}>
                                                    <Label required={choicefields.Required == "Yes" ? true : false}>
                                                      {data()?.CurrentdisplayfieldsName[choicefields.InternalName]}
                                                    </Label>
                                                    <TextField
                                                      id={choicefields.InternalName}
                                                      name={choicefields.FieldName}
                                                      placeholder={
                                                        "Enter " +
                                                        data()?.CurrentdisplayfieldsName[choicefields.InternalName]
                                                      }
                                                      value={dataText[choicefields.InternalName] || ""}
                                                      onChange={gettextvalue}
                                                    ></TextField>
                                                  </div>
                                                ); // ////console.log(choicefields,"choicefields")
                                              if (choicefields.type == "Note")
                                                return (
                                                  <div id={choicefields.InternalName}>
                                                    <Label required={choicefields.Required == "Yes" ? true : false}>
                                                      {data()?.CurrentdisplayfieldsName[choicefields.InternalName]}
                                                    </Label>
                                                    <TextField
                                                      id={choicefields.InternalName}
                                                      name={choicefields.FieldName}
                                                      placeholder={
                                                        "Enter " +
                                                        data()?.CurrentdisplayfieldsName[choicefields.InternalName]
                                                      }
                                                      value={dataNote[choicefields.InternalName] || ""}
                                                      onChange={getnotevalue}
                                                      multiline
                                                    ></TextField>
                                                  </div>
                                                );
                                              if (choicefields.type == "Number")
                                                return (
                                                  <div id={choicefields.InternalName}>
                                                    <Label>
                                                      {data()?.CurrentdisplayfieldsName[choicefields.InternalName]}
                                                    </Label>
                                                    <TextField
                                                      id={choicefields.InternalName} //value={choicefields.FieldName}
                                                      value={dataNumber[choicefields.InternalName] || ""}
                                                      placeholder={
                                                        "Enter " +
                                                        data()?.CurrentdisplayfieldsName[choicefields.InternalName]
                                                      }
                                                      // name={choicefields.FieldName}
                                                      type="Number"
                                                      onChange={getnumbervalue}
                                                    ></TextField>
                                                  </div>
                                                );
                                              if (choicefields.type == "DateTime")
                                                return (
                                                  <div id={choicefields.InternalName}>
                                                    <Label required={item.Required == "Yes" ? true : false}>
                                                      {data()?.CurrentdisplayfieldsName[choicefields.InternalName]}
                                                    </Label>
                                                    <DatePicker
                                                        showWeekNumbers={true}
                                                        showMonthPickerAsOverlay={true}
                                                      id={choicefields.InternalName}
                                                      onSelectDate={(date) =>
                                                        ondobChange(date, choicefields.InternalName)
                                                      }
                                                      // value={Dateofbirth == undefined || Dateofbirth == null ? null : new Date(Dateofbirth)}
                                                      placeholder={
                                                        "Enter " +
                                                        data()?.CurrentdisplayfieldsName[choicefields.InternalName]
                                                      }
                                                      value={
                                                        dateDatepicker[choicefields.InternalName]
                                                          ? dateDatepicker[choicefields.InternalName]
                                                          : null
                                                      }
                                                      formatDate={onFormatDate}
                                                    />
                                                  </div>
                                                );
                                            })
                                          : null;
                                        // })
                                      }
                                    })
                                  : null}
                              </>
                            );
                          }
                          if (item.Type == "Plus") {
                            return (
                              <>
                                <div id={item.IntName} className={"pluseicondiv"}>
                                  <div className={"counterdiv"}>
                                    <Label required={item.Required == "Yes" ? true : false}>{item.text}</Label>

                                    {/* <ChoiceGroup selectedKey={selectedChoiceKey} options={counterpartyoption} onChange={onChangechoicegrp}/> */}
                                    {/* <div
                                      onClick={() => {
                                        showDialog();
                                        setData((c) => ({
                                          ...c,
                                          counterparty: true,
                                        }));
                                      }}
                                      style={{ display: "flex" }}
                                    >
                                      <Icon
                                        //  title={strings.Add}
                                        onClick={
                                          () => {
                                            showDialog();
                                            //  openPanelDept();
                                          } //EditUser(templ.Id)
                                        }
                                        iconName="Add"
                                        styles={{
                                          root: {
                                            color: "var(--layoutIconColor) !important",

                                            cursor: "pointer",
                                            marginRight: "5px",
                                            marginTop: "8px",
                                          },
                                        }}
                                      />
                                      <Label
                                        styles={{
                                          root: {
                                            cursor: "pointer",
                                            color: "var(--layoutIconColor) !important",
                                          },
                                        }}
                                      >
                                        {strings.Add}
                                      </Label>
                                    </div> */}
                                  </div>

                                  <div className={"counterdiv1"}>
                                    <Select
                                      theme={SelectTheme}
                                      placeholder={strings.Selectcounterparty}
                                      maxMenuHeight={200}
                                      options={item.IntName ==="Share_With_Others" ? ShareWith().ShareWithOptions.sort((a, b) => a?.label.localeCompare(b?.label)) : data()?.optionsCounterparty}
                                      onChange={(select) => onChangeCParty(select, item.IntName)}
                                      isSearchable={true}
                                      value={item.IntName === "Share_With_Others"
                                            ? ShareWith()?.shareWithSelected
                                            : data()?.optionsCounterparty?.filter((el) =>
                                        data()?.counterpartyname.some((f) => f.key === el.key)
                                      )}
                                      isMulti={true}
                                    />
                                  </div>
                                </div>
                              </>
                            );
                          }
                          if (item.Type == "Datecheck" && item.IntName !== "Contract_Term") {
                            return (
                              <>
                                <div id={item.IntName}>
                                  <Label required={item.Required == "Yes" ? true : false}>{item.text}</Label>
                                  <div className={"iconHideMBNavClassnew"}>
                                    <ChoiceGroup
                                      styles={choiceGroupStyles}
                                      selectedKey={data()?.selectedChoiceKey}
                                      options={counterpartyoption}
                                      onChange={onChangechoicegrp}
                                    />
                                  </div>
                                </div>
                              </>
                            );
                          }
                          if (item.Type == "DateTime" && item.IntName !== "Contract_Date") {
                            return (
                              <>
                                <div id={item.IntName} style={{ position: "relative" }}>
                                  <span
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Label
                                      required={
                                        item.IntName == "Contract_End_Date" && data()?.selectedTerm == "Indefinite"
                                          ? false
                                          : item.Required == "Yes"
                                            ? true
                                            : false
                                      }
                                    >
                                      {" "}
                                      {data()?.CurrentdisplayfieldsName[item.IntName]}
                                    </Label>
                                  </span>

                                  {data()?.showDurationTextField && item.IntName == "Contract_End_Date" && (
                                    <TextField
                                      // id={item.IntName}
                                      id="textFieldTerm"
                                      placeholder={"Select " + data()?.CurrentdisplayfieldsName[item.IntName]}
                                      // placeholder={"Enter " + item.text}
                                      name={item.text}
                                      readOnly
                                      onClick={() => {
                                        // if(selectedChoiceKey != "Indefinite"){
                                        // if (!selectedTerm.includes("Indefinite")) {
                                        if (!dateDatepicker["Contract_Start_Date"]) {
                                          Sweetalerteditrequest("error", `Please select start date`);
                                        } else {
                                          setIsTermDialogvisible(true);
                                          setData((c) => ({
                                            ...c,
                                            isTermDialogvisible: true,
                                          }));
                                          // }
                                        }
                                      }}
                                      value={data()?.isDisabled ? data()?.selectedTerm : data()?.Contract_End_Date}
                                      //  disabled={selectedTerm === "Indefinite"}
                                      disabled={data()?.isDisabled}
                                    ></TextField>
                                  )}
                                  {(item.IntName !== "Contract_End_Date" ||
                                    !data()?.showDurationTextField ||
                                    dateDatepicker[item.IntName]) && (
                                    <DatePicker
                                    showWeekNumbers={true}
                                    showMonthPickerAsOverlay={true}
                                      id={item.IntName}
                                      onSelectDate={(date) => ondobChange(date, item.IntName)}
                                      {...(dateDatepicker[item.IntName]
                                        ? {
                                            value:
                                              item.IntName == "Contract_End_Date" &&
                                              data()?.selectedTerm == "Indefinite"
                                                ? null
                                                : dateDatepicker[item.IntName] || null,
                                          }
                                        : {})}
                                      //  value={
                                      //   dateDatepicker[item.IntName]? dateDatepicker[item.IntName] : {}
                                      // }
                                      placeholder={"Enter " + data()?.CurrentdisplayfieldsName[item.IntName]}
                                      formatDate={onFormatDate}
                                      disabled={
                                        item.IntName == "Contract_End_Date" && data()?.selectedTerm == "Indefinite"
                                          ? true
                                          : false
                                      }
                                    />
                                  )}
                                  {item.IntName == "Contract_End_Date" && dateDatepicker[item.IntName] && (
                                    <Icon
                                      iconName="Cancel"
                                      // onClick={clearTextField}
                                      onClick={() => {
                                        setdateDatepicker((prevState) => ({
                                          ...prevState,
                                          Contract_End_Date: null,
                                        }));
                                        setdataChoice2(prev => ({
                                          ...prev,
                                          Payment_Term: "One Time"
                                        }));
                                        // setShowDurationTextField(true);
                                        // setiscloseVisible(true);
                                        setData((c) => ({
                                          ...c,
                                          iscloseVisible: true,
                                          showDurationTextField: true,
                                        }));
                                      }}
                                      styles={{
                                        root: {
                                          position: "absolute",
                                          right: 30,
                                          top: 38,
                                          // transform: 'translateY(-50%)',
                                          cursor: "pointer",
                                          fontSize: 17,
                                          color: "rgb(96, 94, 92)",
                                        },
                                      }}
                                    />
                                  )}
                                  {data()?.isDisabled && item.IntName == "Contract_End_Date" && (
                                    <Icon
                                      iconName="Cancel"
                                      // onClick={clearTextField}
                                      onClick={() => {
                                        setData((c) => ({
                                          ...c,
                                          isDisabled: false,
                                          iscloseVisible: true,
                                          selectedTerm: "",
                                        }));
                                      }}
                                      styles={{
                                        root: {
                                          position: "absolute",
                                          right: 10,
                                          top: 38,
                                          // transform: 'translateY(-50%)',
                                          cursor: "pointer",
                                          fontSize: 17,
                                          color: "rgb(96, 94, 92)",
                                        },
                                      }}
                                    />
                                  )}
                                </div>
                              </>
                            );
                          }
                          if (
                            item.Type == "Attachments" //&& item.Display == true
                          ) {
                            return (
                              <>
                                <div>
                                  <Label required={item.Required == "Yes" ? true : false}>
                                    {" "}
                                    {data()?.CurrentdisplayfieldsName[item.IntName]}
                                  </Label>
                                  <div>
                                    {attachmentFileData[item.IntName] == null ||
                                    attachmentFileData[item.IntName]?.length == 0 ? (
                                      <CustomAttachment
                                        showLabel={false}
                                        onChangeAdd={(ev) => {
                                          onCustomAttachmentChange(
                                            ev,
                                            item.IntName,
                                            data()?.attachmentFileDataTemp[item.IntName]
                                          );
                                        }}
                                        accept=".docx,.pdf,.doc,.jpg,.jpeg,.png,.zip,.xlsx,.xls"
                                        selectedFile={attachmentFileData[item.IntName]?.[0]}
                                        key={JSON.stringify(attachmentFileData[item.IntName]?.[0])}
                                      />
                                    ) : null}
                                    {attachmentFileData[item.IntName]?.[0]}
                                  </div>
                                </div>
                              </>
                            );
                          }
                          if (
                            item.Type == "Choice" //&& item.Display == true
                          ) {
                            let optionscond;
                            data()?.conditionaldata
                              ? data()?.conditionaldata.map((items) => {
                                  //  ////console.log(items.internalname, item.IntName, items.value)
                                  if (items.internalname == item.IntName) {
                                    optionscond = items.value;
                                  }
                                })
                              : null;
                            return (
                              <>
                                <div>
                                  <Label required={item.Required == "Yes" ? true : false}>
                                    {" "}
                                    {data()?.CurrentdisplayfieldsName[item.IntName]}
                                  </Label>
                                  <Dropdown
                                    placeholder="Select Choice"
                                    id={item.IntName}
                                    // label={iterm.DisplayName}
                                    selectedKey={dataChoice2[item.IntName] ? dataChoice2[item.IntName] : null}
                                    // options={optionscond}
                                    responsiveMode={ResponsiveMode.large}
                                    options={item.IntName==="Payment_Term" ? getFilteredPaymentTerms(dateDatepicker?.['Contract_Start_Date'], dateDatepicker?.['Contract_End_Date'], data()?.selectedTerm):optionscond}
                                    disabled={item.IntName==="Payment_Term" ? !dateDatepicker?.['Contract_Start_Date'] || (!dateDatepicker?.['Contract_End_Date'] && data()?.selectedTerm !== 'Indefinite') : false}
                                    onChange={(e, items) => getChoice(items, item.IntName)}
                                  />
                                </div>
                                {finalconditional
                                  ? Object.entries(finalconditional).map(([Outerkey, column]: any, index: any) => {
                                      if (item.IntName == Outerkey) {
                                        return Object.entries(column).map(
                                          ([Innerkey, innerfields]: any, index: any) => {
                                            return innerfields.Fields.length
                                              ? innerfields.Fields.map((choicefields) => {
                                                  if (choicefields.type == "Text")
                                                    return (
                                                      <div id={choicefields.InternalName}>
                                                        <Label required={choicefields.Required == "Yes" ? true : false}>
                                                          {data()?.CurrentdisplayfieldsName[choicefields.InternalName]}
                                                        </Label>
                                                        <TextField
                                                          id={choicefields.InternalName}
                                                          value={dataText[choicefields.InternalName] || ""}
                                                          placeholder={
                                                            "Enter " +
                                                            data()?.CurrentdisplayfieldsName[choicefields.InternalName]
                                                          }
                                                          name={choicefields.FieldName}
                                                          onChange={gettextvalue}
                                                        ></TextField>
                                                      </div>
                                                    ); // ////console.log(choicefields,"choicefields")
                                                  if (choicefields.type == "Note")
                                                    return (
                                                      <div id={choicefields.InternalName}>
                                                        <Label required={choicefields.Required == "Yes" ? true : false}>
                                                          {data()?.CurrentdisplayfieldsName[choicefields.InternalName]}
                                                        </Label>
                                                        <TextField
                                                          id={choicefields.InternalName}
                                                          value={dataNote[choicefields.InternalName] || ""}
                                                          name={choicefields.FieldName}
                                                          onChange={getnotevalue}
                                                          placeholder={
                                                            "Enter " +
                                                            data()?.CurrentdisplayfieldsName[choicefields.InternalName]
                                                          }
                                                          multiline
                                                        ></TextField>
                                                      </div>
                                                    );
                                                  if (choicefields.type == "Number")
                                                    return (
                                                      <>
                                                        <div id={choicefields.InternalName}>
                                                          <Label>
                                                            {
                                                              data()?.CurrentdisplayfieldsName[
                                                                choicefields.InternalName
                                                              ]
                                                            }
                                                          </Label>
                                                          <TextField
                                                            id={choicefields.InternalName}
                                                            placeholder={
                                                              "Enter " +
                                                              data()?.CurrentdisplayfieldsName[
                                                                choicefields.InternalName
                                                              ]
                                                            }
                                                            value={dataNumber[choicefields.InternalName] || ""}
                                                            //  name="value"
                                                            type="Number"
                                                            onChange={getnumbervalue}
                                                          ></TextField>
                                                        </div>
                                                      </>
                                                    );
                                                  if (choicefields.type == "DateTime")
                                                    return (
                                                      <div id={choicefields.InternalName}>
                                                        <Label required={item.Required == "Yes" ? true : false}>
                                                          {data()?.CurrentdisplayfieldsName[choicefields.InternalName]}
                                                        </Label>
                                                        <DatePicker
                                                            showWeekNumbers={true}
                                                            showMonthPickerAsOverlay={true}
                                                          id={choicefields.InternalName}
                                                          onSelectDate={(date) =>
                                                            ondobChange(date, choicefields.InternalName)
                                                          }
                                                          // value={Dateofbirth == undefined || Dateofbirth == null ? null : new Date(Dateofbirth)}
                                                          value={
                                                            dateDatepicker[choicefields.InternalName]
                                                              ? dateDatepicker[choicefields.InternalName]
                                                              : null
                                                          }
                                                          placeholder={
                                                            "Enter " +
                                                            data()?.CurrentdisplayfieldsName[choicefields.InternalName]
                                                          }
                                                          formatDate={onFormatDate}
                                                        />
                                                      </div>
                                                    );
                                                })
                                              : null;
                                          }
                                        );
                                      }
                                    })
                                  : null}
                              </>
                            );
                          }
                          if(item.Type == "NumberWithSuffix"&&item.IntName=="Contract_Cost"){
                          return (
                          <div style={{display: 'flex', flexDirection: 'column'}}><Label>{`Contract Cost${dataChoice2?.['Payment_Term'] && dataChoice2['Payment_Term'] !== "One Time" ? ` - ${dataChoice2['Payment_Term']}` : ""}`}</Label>
                           <ContractCostTextField  ContractCostData={ContractCostData} setContractCostData={setContractCostData} disabled={!dateDatepicker?.['Contract_Start_Date'] || (!dateDatepicker?.['Contract_End_Date'] && data()?.selectedTerm !== 'Indefinite')}/></div>)
                        }
                        })}
                        {/* </div></div></div></div> */}
                      </div>
                    </>
                  );
                  //}
                })
              : null}
          </div>

          <div>
            {data()?.documentTypes && data()?.documentTypes?.length > 0 && (
              <>
                <h3
                  style={{
                    marginBottom: "8px",
                    color: SettingService.GetTheme() == "dark" ? "#fff" : "#000",
                  }}
                >
                  {data()?.documenttitle}
                </h3>
                {data()?.documentTypes ? (
                  <div style={{ borderBottom: "1.5px solid var(--lightdarkBGTable)" }}></div>
                ) : (
                  <div style={{ borderBottom: "1.5px solid var(--lightdarkBGTable)" }} />
                )}
                <div className={"addnewrequestersection"}>
                  {data()?.documentTypes &&
                    data()?.documentTypes?.map((item) => {
                      if (item.Type === "Attachments") {
                        return (
                          <div key={item.IntName}>
                            <Label required={item.Required === "Yes"}>
                              {data()?.CurrentdisplayDocfields[item.IntName] || item?.IntName}
                            </Label>
                            <div>
                              {documentTypesData[item.IntName] == null ||
                              documentTypesData[item.IntName]?.length === 0 ? (
                                <CustomAttachment
                                  showLabel={false}
                                  onChangeAdd={(ev) => {
                                    onDocumentTypeChange(ev, item.IntName, data()?.documentTypesKeyPairs[item.IntName]);
                                  }}
                                  accept=".docx,.pdf,.doc,.jpg,.jpeg,.png,.zip,.xlsx,.xls"
                                  selectedFile={documentTypesData[item.IntName]?.[0]}
                                  key={JSON.stringify(documentTypesData[item.IntName]?.[0])}
                                />
                              ) : null}
                              {documentTypesData[item.IntName]?.[0]}
                            </div>
                          </div>
                        );
                      }
                      return null;
                    })}
                </div>
              </>
            )}
          </div>
          {formfieldjson ? (
            <div
              id="Sweetalertremarksdailoge"
              onDragOver={handleDrag}
              onDragLeave={handleDragLeave}
              style={{ marginTop: "5px" }}
            >
              {/* <Label required>Remarks</Label> */}
              <h3
                style={{
                  marginBottom: "8px",
                  color: SettingService.GetTheme() == "dark" ? "#fff" : "#000",
                }}
              >
                {strings.Remarks} <span style={{ color: "rgb(164, 38, 44)" }}>*</span>
              </h3>
              <div
                style={{
                  borderBottom: "1.5px solid var(--lightdarkBGTable)",
                  marginBottom: "5px",
                }}
              ></div>
               {/* <TextField
                multiline
                value={data()?.remark || ""}
                rows={5}
                onChange={(ev, newVal) => {
                  setData((c) => ({
                    ...c,
                    remark: newVal,
                  }));
                }}
              />  */}
               <ReactQuill
                style={{ width: "100%", height: "100px" }}
                ref={(el) => (reactQuillRef.current = el)}
                theme="snow"
                value={data()?.remark || ""}
                onChange={handleTextChange}
                />
              <>
                <label
                  htmlFor="DragandDropFileId"
                  style={{
                    display: "flex",
                    marginTop: "4.5rem",
                    width: "fit-content",
                  }}
                >
                  <Label htmlFor="DragandDropFileId" style={{ display: "flex" }}>
                    <div>
                      <span>{strings.AttachmentsHome}</span>
                    </div>
                    <div style={{ marginTop: "2px", marginLeft: "4px" }}>
                      <Icon
                        iconName="Attach"
                        style={{ height: "25px", marginLeft: "5px" }}
                        styles={{
                          root: {
                            color: "var(--layoutIconColor)",
                          },
                        }}
                      ></Icon>
                    </div>
                  </Label>
                  {/* className={"imgload"} */}
                  <div className={"imgload"}>
                    <TooltipHost content={strings.attachment} id="field4" styles={hostStyles}>
                      <IconButton
                        id="field4"
                        aria-describedby="field4"
                        style={{ height: "22px", marginLeft: "0px" }}
                        iconProps={{ iconName: "Info" }}
                        styles={{
                          icon: {
                            color: "var(--layoutIconColor)",
                          },
                        }}
                        className={"info"}
                      ></IconButton>
                    </TooltipHost>
                  </div>
                </label>
                <DragAndDrop
                  FileID="DragandDropFileId"
                  draggableContainerStyle={{
                    minHeight: "5px",
                    height: heightValue,
                    marginTop: "-1rem",
                  }}
                  draggableContainerStyle1={{ left: "44%" }}
                  showLabel={false}
                  multiple={true}
                  onChangeAdd={onAttachmentChangeremark}
                  accept=".docx,.pdf,.doc"
                  selectedFile={data()?.attachremarkFile1}
                  key={JSON.stringify(data()?.attachremarkFile1)}
                />
                <div className="ModalAttachmentsDivrequestform">{data()?.attachremarkFile1}</div>
              </>
            </div>
          ) : (
            ""
          )}
          <div style={{ paddingBottom:'25px' }} onDragOver={handleDrag} onDragLeave={handleDragLeave}>
            {formfieldjson ? (
              <div className={"Buttons"}>
                <PrimaryButton
                  disabled={loading}
                  text={ButtonSaveText1}
                  allowDisabledFocus
                  className={"savebutton"}
                  onClick={() => {
                    if (data()?.status == "Rejected") {
                      setRejectedSubmit("Yes");
                    }
                    openDialogRemark();
                  }}
                >
                  {loading && (
                    <div className={"elementToFadeInAndOut"}>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  )}
                </PrimaryButton>
                {data()?.status == "Rejected" ? (
                  <DefaultButton
                    // disabled={disableButton}
                    text={Buttonsubmit}
                    // allowDisabledFocus
                    // className={"savebutton"}
                    className={"DefaultButtonrequestedit"}
                    onClick={() => {
                      // setRejectedSubmit("Yes");
                      // openDialogRemark()
                      PostContractformdata("Publish", approvalInfo);
                    }}
                  >
                    {loading3 && (
                      <div className={"elementToFadeInAndOut1"}>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    )}
                  </DefaultButton>
                ) : null}
                {data()?.Statusvalue == "Draft" ? (
                  <DefaultButton
                    text={ButtonSaveText}
                    className={"DefaultButtonrequestedit"}
                    onClick={() => PostContractformdata("Draft", approvalInfo)}
                  >
                    {loading1 && (
                      <div className={"elementToFadeInAndOut1"}>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    )}
                  </DefaultButton>
                ) : null}
              </div>
             ) : (
              ""
            )} 
          </div>

        </div>
      )}

{/* {isDialogvisible == true && (
          <Dialog
            hidden={!isDialogvisible}
            onDismiss={hideDialog}
            dialogContentProps={dialogContentProps}
            modalProps={modalProps}
            styles={dialogStyles}
          >
            <div id="SweetAlertsCounterparty" />
            <Counterparty
              fetchdata={getcounterpartyDetails}
              closedialog={hideDialog}
              setcounterpartyname={setcounterpartyname}
              optionsCounterparty={optionsCounterparty}
              reqcounterparty={counterparty}
            />
          </Dialog>
        )} */}

{isTermDialogvisible && (
          <Callout
            className={stylesCallout.callout}
            role="dialog"
            gapSpace={0}
            // target={`#addRequestTerm`}
            target={`#textFieldTerm`}
            onDismiss={hideDialog}
            setInitialFocus
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Label>{"Add Term"}</Label>
              <Icon
                iconName="ChromeClose"
                styles={{ root: { fontSize: 12, cursor: "pointer" } }}
                onClick={() =>setIsTermDialogvisible(false) }
              ></Icon>
            </div>
            <AddTermDialog
              addTermCallback={handleTermCallback}
              defaultValues={data()?.termObj}
              onTermChangeCallback={handleTermChange}
              isTermDialogvisible={isTermDialogvisible}
            />
          </Callout>
        )}
             </div>
    </div>
  );
}

export default UpdateExisting;
